/* basn5.js — generated by scripts/build-basn5-js.js from gold-standard js/basn5.js.
   Edits: cdn() path resolution, Shopify customize link, and the real two-line cart bridge.
   DO NOT EDIT BY HAND — edit the gold source or scripts/basn5-cart-snippet.js and rebuild. */
/* ==========================================================================
   basn5.js — Interactions for basn5.com
   Vanilla JS, no frameworks. Powers both homepage and product pages.
   ========================================================================== */

(function () {
  'use strict';

  /* ==========================================================================
     Utility: requestAnimationFrame-throttled scroll handler
     Instead of firing on every scroll pixel, we batch scroll callbacks
     into animation frames so the browser stays smooth.
     ========================================================================== */

  function onScroll(callback) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          callback();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }


  /* ==========================================================================
     1. Sticky Navigation — scroll behavior
     - Starts transparent over the hero image.
     - Turns solid (white) once the user scrolls past 100px.
     - Hides when scrolling down, reappears when scrolling up.
     - Uses a 10px threshold to avoid jittery show/hide on tiny movements.
     ========================================================================== */

  function initNav() {
    var nav = document.querySelector('.b5-nav');
    if (!nav) return;

    var solidBreakpoint = 100;        // px before nav turns solid

    /* If the nav starts as solid (no hero on this page), skip the
       transparent/solid toggling — the nav is already correct. */
    var startsSolid = nav.classList.contains('b5-nav--solid');

    /* Phase 5: nav stays visible at all times — no auto-hide on scroll-down.
       The only thing that changes on scroll is the transparent → solid
       background transition once we leave the hero area. */
    onScroll(function () {
      if (startsSolid) return;

      var currentY = window.scrollY;
      if (currentY > solidBreakpoint) {
        nav.classList.add('b5-nav--solid');
        nav.classList.remove('b5-nav--transparent');
      } else {
        nav.classList.remove('b5-nav--solid');
        nav.classList.add('b5-nav--transparent');
      }
    });

    /* Defensively strip the legacy hidden class in case any page has it
       baked into the markup. */
    nav.classList.remove('b5-nav--hidden');
  }


  /* ==========================================================================
     2. Mobile Hamburger Menu
     - Toggle button (.b5-nav__toggle) opens/closes the nav links container.
     - Clicking any link inside the menu closes it automatically.
     ========================================================================== */

  function initMobileMenu() {
    var toggle = document.querySelector('.b5-nav__toggle');
    var links = document.querySelector('.b5-nav__links');
    if (!toggle || !links) return;
    var nav = toggle.closest('.b5-nav');

    function setOpen(open) {
      toggle.classList.toggle('open', open);
      links.classList.toggle('open', open);
      if (nav) nav.classList.toggle('b5-nav--menu-open', open);
      document.body.classList.toggle('b5-menu-open', open);
    }

    toggle.addEventListener('click', function () {
      setOpen(!toggle.classList.contains('open'));
    });

    /* Close the menu when any nav link is tapped */
    var navLinks = links.querySelectorAll('a');
    navLinks.forEach(function (link) {
      link.addEventListener('click', function () { setOpen(false); });
    });
  }


  /* ==========================================================================
     3. Smooth Scroll for Anchor Links
     - Any link whose href starts with "#" scrolls smoothly to the target.
     - Accounts for the fixed nav bar height (~70px) so the section isn't
       hidden behind it.
     ========================================================================== */

  function initSmoothScroll() {
    var NAV_HEIGHT = 70; // approximate height of the sticky nav

    document.addEventListener('click', function (e) {
      var anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;

      var targetId = anchor.getAttribute('href');
      if (targetId === '#') return; // bare "#" links — skip

      var target = document.querySelector(targetId);
      if (!target) return;

      e.preventDefault();

      var top = target.getBoundingClientRect().top + window.scrollY - NAV_HEIGHT;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }


  /* ==========================================================================
     4. Fade-In on Scroll (Intersection Observer)
     - Elements with class "b5-fade-in" start invisible (CSS: opacity 0,
       translateY 24px).
     - When they scroll into view, we add the "visible" class which triggers
       the CSS transition.
     - Once visible, we stop observing them — they stay visible forever.
     - Stagger delays are handled entirely in CSS via the .b5-stagger parent.
     ========================================================================== */

  function initFadeIn() {
    var elements = document.querySelectorAll('.b5-fade-in');
    if (!elements.length) return;

    /* Fall back gracefully if IntersectionObserver isn't available */
    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target); // don't re-hide
        }
      });
    }, {
      threshold: 0.15 // trigger when 15% of the element is visible
    });

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }


  /* ==========================================================================
     5. Carousel — touch-friendly horizontal scroll with dots
     - The scroll container (.b5-carousel__track) uses CSS overflow-x: auto
       and scroll-snap for the actual scrolling / touch behavior.
     - If a .b5-carousel__dots sibling exists, we auto-generate dot buttons
       (one per slide) and keep the active dot in sync as the user scrolls.
     ========================================================================== */

  function initCarousels() {
    var carousels = document.querySelectorAll('.b5-carousel__track');
    if (!carousels.length) return;

    carousels.forEach(function (track) {
      var slides = track.querySelectorAll('.b5-carousel__slide');
      if (!slides.length) return;

      /* Look for a dots container as a sibling of the track */
      var dotsContainer = track.parentElement
        ? track.parentElement.querySelector('.b5-carousel__dots')
        : null;

      if (!dotsContainer) return; // no dots needed

      /* --- Generate one dot button per slide --- */
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.classList.add('b5-carousel__dot');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) dot.classList.add('active');
        dotsContainer.appendChild(dot);
      });

      var dots = dotsContainer.querySelectorAll('.b5-carousel__dot');

      /* --- Clicking a dot scrolls to that slide --- */
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          slides[i].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        });
      });

      /* --- Update active dot as the user scrolls --- */
      if ('IntersectionObserver' in window) {
        var slideObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var index = Array.prototype.indexOf.call(slides, entry.target);
              dots.forEach(function (d) { d.classList.remove('active'); });
              if (dots[index]) dots[index].classList.add('active');
            }
          });
        }, {
          root: track,
          threshold: 0.5 // at least half the slide must be visible
        });

        slides.forEach(function (slide) {
          slideObserver.observe(slide);
        });
      }
    });
  }


  /* ==========================================================================
     6. Accordion — expand / collapse sections
     - Standard accordions (.b5-accordion): toggle "open" class on click.
       Multiple can be open at once.
     - Triad expands (.b5-triad-expand): same pattern but only one can be
       open at a time — opening one closes the others.
     ========================================================================== */

  function initAccordions() {
    /* --- Standard accordions (multiple can be open) --- */
    var accordions = document.querySelectorAll('.b5-accordion');
    accordions.forEach(function (accordion) {
      var trigger = accordion.querySelector('.b5-accordion__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        accordion.classList.toggle('open');
      });
    });

    /* --- Triad expands (only one open at a time) --- */
    var triads = document.querySelectorAll('.b5-triad-expand');
    triads.forEach(function (triad) {
      var trigger = triad.querySelector('.b5-triad-expand__toggle');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = triad.classList.contains('open');

        // Close all triad expands first
        triads.forEach(function (t) { t.classList.remove('open'); });

        // If this one was closed, open it; if it was open, it stays closed
        if (!isOpen) {
          triad.classList.add('open');
        }
      });
    });
  }


  /* ==========================================================================
     6b. Details Accordion — Highway 1 PDP
     - Six-row accordion with .accordion__head <button> triggers. Toggles
       .open on the parent .accordion__row + flips aria-expanded /
       aria-hidden for screen readers. Multi-open is intentional.
     - In-the-box card hover-swap: on touch devices (hover: none) the swap
       happens on tap instead of hover (Option A in the brief).
     ========================================================================== */
  function initDetailsAccordion() {
    var heads = document.querySelectorAll('.details .accordion__head');
    heads.forEach(function (head) {
      head.addEventListener('click', function () {
        var row = head.parentElement;
        var isOpen = row.classList.toggle('open');
        head.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        var bodyId = head.getAttribute('aria-controls');
        if (bodyId) {
          var body = document.getElementById(bodyId);
          if (body) body.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        }
      });
    });

    /* Tap-to-toggle the in-the-box hover image. Attached on every
       device (no matchMedia gate) so it works on phones, tablets,
       hybrid touchscreen laptops, and desktops alike. On desktop
       with a mouse the CSS :hover swap still wins for hover
       interactions; clicking on the image is an additional way to
       lock the "hover" state on/off. */
    document.querySelectorAll('.details .box-item .ph').forEach(function (ph) {
      ph.addEventListener('click', function () {
        ph.classList.toggle('show-hover');
      });
    });
  }


  /* ==========================================================================
     6b. Shared Rx-form helpers
     Used by both the customize page (initCustomize) and the product
     pages (initRxFlow). Keeping these as top-level functions inside the
     module IIFE lets both call sites share identical behavior for:
       - populateRxSelects: filling sphere / cylinder / axis / add dropdowns
       - initRxDropzone:    wiring an upload dropzone (click, drag-drop,
                            filename display, remove)
       - initPdHelpToggles: expanding the "what is PD?" help body
     ========================================================================== */

  function populateRxSelects(rootEl) {
    if (!rootEl) return;

    function fmtDiopter(v) {
      var rounded = Math.round(v * 100) / 100;
      if (rounded > 0) return '+' + rounded.toFixed(2);
      if (rounded < 0) return rounded.toFixed(2); // toFixed already includes the minus
      return '0.00';
    }
    function diopterRange(min, max, step) {
      var arr = [];
      for (var v = min; v <= max + 0.0001; v += step) {
        var rounded = Math.round(v * 100) / 100;
        arr.push({ value: rounded.toFixed(2), text: fmtDiopter(rounded) });
      }
      return arr;
    }
    function axisRange() {
      var arr = [{ value: 'na', text: 'N/A' }];
      for (var i = 1; i <= 180; i++) {
        arr.push({ value: String(i), text: String(i) });
      }
      return arr;
    }
    function fill(select, options, blankBefore) {
      if (!select) return;
      /* Where to insert the blank "—" option in the list. SPH/CYL get it
         right before "0.00" so the native dropdown opens scrolled near
         zero (browser auto-scrolls to the selected option). AXIS/ADD
         have no natural center, so blank stays at the top. Blank is
         always the selected option — field value stays empty until the
         user actively picks. */
      var insertIdx = 0;
      if (blankBefore) {
        for (var i = 0; i < options.length; i++) {
          if (options[i].value === blankBefore) { insertIdx = i; break; }
        }
      }
      for (var j = 0; j <= options.length; j++) {
        if (j === insertIdx) {
          var blank = document.createElement('option');
          blank.value = '';
          blank.textContent = '—';
          blank.selected = true;
          select.appendChild(blank);
        }
        if (j < options.length) {
          var o = document.createElement('option');
          o.value = options[j].value;
          o.textContent = options[j].text;
          select.appendChild(o);
        }
      }
    }

    var ranges = {
      sph: diopterRange(-10, 10, 0.25),
      cyl: diopterRange(-8, 8, 0.25),
      axis: axisRange(),
      add: diopterRange(0.25, 4.00, 0.25)
    };
    var blankBefore = { sph: '0.00', cyl: '0.00' };

    rootEl.querySelectorAll('[data-rx-field]').forEach(function (sel) {
      var field = sel.getAttribute('data-rx-field');
      if (ranges[field] && sel.options.length === 0) {
        fill(sel, ranges[field], blankBefore[field]);
      }
    });
  }

  function initRxDropzone(dropzoneEl) {
    if (!dropzoneEl) return;
    var fileInput = dropzoneEl.querySelector('.b5-cust__rx-dropzone-input');
    var prompt = dropzoneEl.querySelector('.b5-cust__rx-dropzone-prompt');
    var fileBlock = dropzoneEl.querySelector('.b5-cust__rx-dropzone-file');
    var filename = dropzoneEl.querySelector('.b5-cust__rx-dropzone-filename');
    var removeBtn = dropzoneEl.querySelector('.b5-cust__rx-dropzone-remove');
    if (!fileInput) return;

    var MAX_BYTES = 10 * 1024 * 1024; // 10 mb
    var ALLOWED = ['image/jpeg', 'image/png', 'application/pdf'];

    function showFile(file) {
      if (!file) return;
      if (ALLOWED.indexOf(file.type) === -1) {
        alert('only jpg, png, and pdf files are accepted.');
        fileInput.value = '';
        return;
      }
      if (file.size > MAX_BYTES) {
        alert('file is too large — max size is 10 mb.');
        fileInput.value = '';
        return;
      }
      if (filename) filename.textContent = file.name;
      if (prompt) prompt.hidden = true;
      if (fileBlock) fileBlock.hidden = false;
    }
    function clearFile() {
      fileInput.value = '';
      if (filename) filename.textContent = '';
      if (prompt) prompt.hidden = false;
      if (fileBlock) fileBlock.hidden = true;
    }

    fileInput.addEventListener('change', function () {
      if (fileInput.files && fileInput.files[0]) showFile(fileInput.files[0]);
    });

    ['dragenter', 'dragover'].forEach(function (evtName) {
      dropzoneEl.addEventListener(evtName, function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropzoneEl.classList.add('is-dragover');
      });
    });
    ['dragleave', 'dragend'].forEach(function (evtName) {
      dropzoneEl.addEventListener(evtName, function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropzoneEl.classList.remove('is-dragover');
      });
    });
    dropzoneEl.addEventListener('drop', function (e) {
      e.preventDefault();
      e.stopPropagation();
      dropzoneEl.classList.remove('is-dragover');
      var files = e.dataTransfer && e.dataTransfer.files;
      if (files && files[0]) {
        try { fileInput.files = files; } catch (_) { /* some browsers block this */ }
        showFile(files[0]);
      }
    });

    if (removeBtn) {
      removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearFile();
      });
    }
  }

  function initPdHelpToggles(rootEl) {
    if (!rootEl) return;
    rootEl.querySelectorAll('[data-pd-help-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('aria-controls');
        var target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        target.hidden = expanded;
      });
    });
  }


  /* ==========================================================================
     6c. Customize page — Build Your Pair configurator
     State machine: frame · framecolor · lens · angle · rxType · rxMethod.
     Each state change re-renders the preview image, crumb, summary,
     info card, total, and toggles availability of angle / lens cards
     based on which studio photos actually exist on disk.
     ========================================================================== */
  function initCustomize() {
    var root = document.querySelector('.b5-cust');
    if (!root) return;

    /* --- Static product data --- */
    var FRAMES = {
      h1:  { name: 'highway 1', price: 365 },
      dav: { name: 'davenport', price: 395 },
      fp:  { name: 'fort point', price: 395 }
    };
    var FRAME_COLORS = { blk: 'black', brn: 'brown' };
    var RX_PRICES   = { none: 0, single: 250, progressive: 350 };
    var RX_LABELS   = {
      none: 'non-prescription',
      single: 'single vision',
      progressive: 'progressive'
    };

    /* Split mirrored lens names into two nowrap spans (tint + finish).
       Used in two places:
       - Summary strip foot-val: mobile CSS forces .lens-finish to
         display:block so finish stacks under tint on its own line.
       - Configurator group head value: both spans inline + nowrap,
         parent has text-align:right; if width forces a wrap it lands
         BETWEEN the two spans (never inside either), and both lines
         stay right-aligned. */
    function formatLensForSummary(name) {
      var parts = name.split(' ');
      if (parts.length >= 3 && parts[parts.length - 1].toLowerCase() === 'mirror') {
        var tint = parts.slice(0, -2).join(' ');
        var finish = parts.slice(-2).join(' ');
        return '<span class="b5-cust__lens-tint">' + tint + '</span> ' +
               '<span class="b5-cust__lens-finish">' + finish + '</span>';
      }
      return name;
    }

    /* Full studio coverage:
       - fr (front), cn (three-quarter), bk (back) → every lens variant
       - sd (side) → frame-color only (lens not visible in temple shot) */
    var ALL_LENSES = ['g15','b15','cr15','gr15','bl15','g15bkm','g15blm','g15svm','b15bkm','b15gdm','b15grm','b15svm','cr15svm','yg40svm'];
    var ALL_ANGLES = { fr: ALL_LENSES, cn: ALL_LENSES, bk: ALL_LENSES, sd: true };
    var PHOTOS = {
      'h1-blk':  ALL_ANGLES,
      'h1-brn':  ALL_ANGLES,
      'dav-blk': ALL_ANGLES,
      'dav-brn': ALL_ANGLES,
      'fp-blk':  ALL_ANGLES,
      'fp-brn':  ALL_ANGLES
    };

    /* --- State --- */
    var state = {
      frame: 'h1',
      framecolor: 'blk',
      angle: 'fr',
      lens: 'g15',
      rxType: 'none',
      rxMethod: 'later',
      tryon: false
    };

    /* Gate the shareable-URL write (in render()) off until the user makes
       their first real selection, so a bare /customize load keeps a clean
       URL (matching the product pages) and only deep-links/normalizes once
       there's an actual choice to capture. Flipped true after the initial paint. */
    var addrBarSync = false;

    /* Pre-select from URL params if present so PDP → customize handoff
       lands the user on their actual selection (frame model + color +
       lens). Unknown / invalid values are ignored. lens is reconciled
       against the chosen frame+color via pickValidLens after frame/
       color are applied — if the requested lens doesn't exist for that
       combo, we fall back gracefully instead of failing to render. */
    try {
      var urlParams = new URLSearchParams(window.location.search);
      /* 'style' is the canonical frame-model param (matches the address-bar
         link we write below); 'frame' is the legacy name still emitted by
         older product-page → customize handoff links, kept for back-compat. */
      var pFrame = urlParams.get('style') || urlParams.get('frame');
      var pColor = urlParams.get('color');
      var pLens  = urlParams.get('lens');
      if (pFrame && FRAMES[pFrame]) state.frame = pFrame;
      if (pColor && FRAME_COLORS[pColor]) state.framecolor = pColor;
      if (pLens && ALL_LENSES.indexOf(pLens) !== -1) state.lens = pLens;
      /* Reconcile lens against frame+color in case the URL combo is
         invalid (e.g. ?lens=yg40svm but the chosen frame doesn't ship
         that combo). */
      state.lens = pickValidLens(state.frame, state.framecolor, state.lens);
    } catch (e) { /* no-op if URLSearchParams unavailable */ }

    /* --- Helpers --- */
    function buildPath(frame, fc, angle, lens) {
      if (angle === 'sd') return cdn('images/' + frame + '-' + fc + '-sd.jpg');
      return cdn('images/' + frame + '-' + fc + '-' + angle + '-' + lens + '.jpg');
    }
    function hasPhoto(frame, fc, angle, lens) {
      var key = frame + '-' + fc;
      if (!PHOTOS[key]) return false;
      if (angle === 'sd') return !!PHOTOS[key].sd;
      return PHOTOS[key][angle] && PHOTOS[key][angle].indexOf(lens) !== -1;
    }
    function pickValidLens(frame, fc, preferred) {
      if (hasPhoto(frame, fc, 'fr', preferred)) return preferred;
      var key = frame + '-' + fc;
      return PHOTOS[key].fr[0];
    }
    function pickValidAngle(frame, fc, lens, preferred) {
      if (hasPhoto(frame, fc, preferred, lens)) return preferred;
      return 'fr'; // front is the safe fallback
    }

    /* --- DOM refs --- */
    var $img       = document.getElementById('cust-image');
    var $crumb     = document.getElementById('cust-crumb');
    var $headFrame = document.getElementById('head-frame');
    var $headColor = document.getElementById('head-color');
    var $headLens  = document.getElementById('head-lens');
    var $headRx    = document.getElementById('head-rx');
    var $footStyle = document.getElementById('foot-style');
    var $footFrame = document.getElementById('foot-frame');
    var $footLens  = document.getElementById('foot-lens');
    var $footRx    = document.getElementById('foot-rx');
    var $infoName  = document.getElementById('info-name');
    var $infoDesc  = document.getElementById('info-desc');
    var $infoNotes = document.getElementById('info-notes');
    var $infoMeta  = document.getElementById('info-meta');
    var $total     = document.getElementById('cust-total');
    var $totalMeta = document.getElementById('cust-meta');
    var $atcPrice  = document.getElementById('atc-price');
    var $custTrust = document.getElementById('atc-trust-text');
    var $rxMethod  = document.getElementById('cust-rx-method');
    var $rxInputs  = document.getElementById('cust-rx-inputs');
    var $rxUpload  = document.getElementById('cust-rx-upload');
    var $rxLater   = document.getElementById('cust-rx-later');
    var $rxTryon   = document.getElementById('cust-tryon');
    /* Progressive-only callout inside the home-try-on box. Toggled in
       render() based on state.rxType so progressive customers see the
       seg-height context at the moment they're considering try-on. */
    var $tryonProgressive  = document.getElementById('cust-tryon-progressive');
    /* Sticky mobile ATC — same pattern as the PDPs. Visibility is
       driven by an IntersectionObserver below; label syncing happens
       inside render() since it depends on the same state as the main
       ATC button. */
    var $stickyBar   = document.getElementById('cust-sticky-atc');
    var $stickyFrame = document.getElementById('cust-sticky-frame');
    var $stickyName  = document.getElementById('cust-sticky-name');
    var $stickyBtn   = document.getElementById('cust-sticky-btn');
    var $mainAtc     = document.getElementById('cust-atc');

    /* --- Render --- */
    function render() {
      var frame = state.frame;
      var fc = state.framecolor;
      var lens = state.lens;
      var angle = state.angle;
      var frameInfo = FRAMES[frame];
      var lensBtn = root.querySelector('.b5-sig-dot[data-lens="' + lens + '"]');
      var lensName = lensBtn ? lensBtn.getAttribute('data-name') : lens;
      var lensDesc = lensBtn ? lensBtn.getAttribute('data-desc') : '';
      var lensNotes = lensBtn ? lensBtn.getAttribute('data-notes') : '';
      var lensMeta = lensBtn ? lensBtn.getAttribute('data-meta') : '';

      /* Main preview image with onerror fallback to front view.
         Also flip the view-<angle> class so the CSS transform matches
         the current shot (PDP gallery pattern — fr/cn need extra scale,
         bk needs a small translateX nudge). */
      $img.classList.add('is-loading');
      $img.classList.remove('view-fr', 'view-cn', 'view-sd', 'view-bk');
      $img.classList.add('view-' + angle);
      $img.onerror = function () {
        this.onerror = null;
        this.src = buildPath(frame, fc, 'fr', lens);
      };
      $img.onload = function () { $img.classList.remove('is-loading'); };
      $img.src = buildPath(frame, fc, angle, lens);

      /* Thumbnail images — each thumb shows the current lens at its angle.
         The side (sd) thumb ignores lens (it's a temple shot, frame-color only). */
      ['fr', 'cn', 'sd', 'bk'].forEach(function (a) {
        var t = document.getElementById('thumb-' + a);
        if (t) t.src = buildPath(frame, fc, a, lens);
      });

      /* Crumb + summary */
      $crumb.textContent = frameInfo.name + ' · ' + FRAME_COLORS[fc] + ' · ' + lensName;
      $headFrame.textContent = frameInfo.name + ' · $' + frameInfo.price;
      $headColor.textContent = FRAME_COLORS[fc];

      $headLens.innerHTML    = formatLensForSummary(lensName);
      $headRx.textContent    = RX_LABELS[state.rxType];
      $footStyle.textContent = frameInfo.name;
      $footFrame.textContent = FRAME_COLORS[fc];
      $footLens.innerHTML    = formatLensForSummary(lensName);
      $footRx.textContent    = (state.rxType === 'none' ? 'non-rx' : RX_LABELS[state.rxType]);

      /* Info section (flat under hairline divider) */
      $infoName.textContent = lensName;
      $infoDesc.textContent = lensDesc;
      if ($infoNotes) $infoNotes.textContent = lensNotes || '';
      $infoMeta.textContent = lensMeta;

      /* Frame card active state — and sync each card's preview image to
         the current frame_color + lens so all three cards reflect what
         the user has built. Angle is always front (fr) regardless of
         the main preview angle: these tiles identify the frame
         silhouette, not the current shot. Every frame/color/lens combo
         has a photo per PHOTOS, so no fallback is needed. */
      root.querySelectorAll('.b5-cust__frame-card').forEach(function (b) {
        var f = b.getAttribute('data-frame');
        var on = f === frame;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var thumb = b.querySelector('.b5-cust__frame-img img');
        if (thumb) thumb.src = buildPath(f, fc, 'fr', lens);
      });
      /* Frame color card active state */
      root.querySelectorAll('.b5-cust__color-card').forEach(function (b) {
        var on = b.getAttribute('data-frame-color') === fc;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      /* Lens dots — uses .active (matches base .b5-sig-dot styling) +
         disables dots whose photo doesn't exist for this frame/color */
      root.querySelectorAll('.b5-cust__sig-row .b5-sig-dot').forEach(function (b) {
        var lensId = b.getAttribute('data-lens');
        var on = lensId === lens;
        var available = hasPhoto(frame, fc, 'fr', lensId);
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.disabled = !available;
      });
      /* Thumbnails — active + disable when angle not available for this lens */
      root.querySelectorAll('.b5-cust__thumb').forEach(function (b) {
        var a = b.getAttribute('data-angle');
        var on = a === angle;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.disabled = !hasPhoto(frame, fc, a, lens);
      });
      /* Rx-type buttons — sync active state to current state.rxType so
         the black selector box moves with the user's choice
         (non-prescription / single vision / progressive). */
      root.querySelectorAll('[data-rx-type]').forEach(function (b) {
        var on = b.getAttribute('data-rx-type') === state.rxType;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      /* Pricing */
      var total = frameInfo.price + RX_PRICES[state.rxType];
      $total.textContent    = '$' + total;
      $atcPrice.textContent = '$' + total;
      var rxTag = state.rxType === 'none' ? 'non-rx' : (RX_LABELS[state.rxType] + ' rx');
      $totalMeta.textContent = frameInfo.name + ' · ' + FRAME_COLORS[fc] + ' frame · ' + lensName + ' lens · ' + rxTag;

      /* Rx conditional UI */
      var needsRx = state.rxType !== 'none';
      var isProgressive = state.rxType === 'progressive';
      $rxMethod.classList.toggle('is-visible', needsRx);
      $rxTryon.classList.toggle('is-visible', needsRx);
      $rxInputs.classList.toggle('is-visible', needsRx && state.rxMethod === 'type');
      $rxUpload.classList.toggle('is-visible', needsRx && state.rxMethod === 'upload');
      $rxLater.classList.toggle('is-visible', needsRx && state.rxMethod === 'later');
      /* Progressive-only seg-height callout inside the home-try-on box. */
      if ($tryonProgressive) {
        $tryonProgressive.classList.toggle('is-visible', isProgressive);
      }
      /* Progressive-only ADD column in the type-in Rx table. The CSS
         show/hides the ADD cells AND swaps grid-template-columns from
         4 to 5 cols when this class is present. */
      var $rxTable = document.getElementById('cust-rx-table');
      if ($rxTable) {
        $rxTable.classList.toggle('is-progressive', isProgressive);
      }

      /* Trust strip — render as two segments (split on "·") + flag .is-rx for the longer
         Rx copy, mirroring the PDP. (Customize has no Rx on/off toggle, so drive it here
         off render(), which already re-runs on every Rx-type change.) */
      if ($custTrust) {
        renderTrust($custTrust, needsRx ? $custTrust.dataset.rx : $custTrust.dataset.default, needsRx);
      }

      /* Sticky mobile ATC mirror — top: "<color> <frame name> Frame"
         (caps via CSS) — single noun phrase, color as adjective.
         Bottom: "[rx ]<lens name> lens" — same noun-phrase pattern.
         "rx " prefix signals a prescription order without spelling
         out single vs progressive (price already encodes that).
         Bar visibility is toggled separately by the
         IntersectionObserver below. */
      if ($stickyFrame) {
        $stickyFrame.textContent = frameInfo.name + ' · ' + FRAME_COLORS[fc] + ' frame';
      }
      if ($stickyName) {
        var rxPrefix = state.rxType && state.rxType !== 'none' ? 'rx ' : '';
        $stickyName.textContent = lensName ? (rxPrefix + lensName + ' lens') : '';
      }
      if ($stickyBtn) {
        $stickyBtn.textContent = 'add to cart — $' + total;
      }

      /* Reflect the current build (frame style + frame color + lens) in the
         address bar so the page URL is a shareable deep-link to exactly this
         configuration. Rx is deliberately NOT encoded (it's personal + drives
         price). replaceState (not pushState) keeps the back button clean, and
         editing the existing URL preserves any other query params. */
      try {
        if (addrBarSync && window.history && history.replaceState) {
          var sharedUrl = new URL(window.location.href);
          sharedUrl.searchParams.set('style', frame);
          sharedUrl.searchParams.set('color', fc);
          sharedUrl.searchParams.set('lens', lens);
          sharedUrl.searchParams.delete('frame'); // normalize away the legacy model param name
          history.replaceState(null, '', sharedUrl.toString());
        }
      } catch (e) { /* no-op if URL/history unavailable */ }
    }

    /* --- Event handlers --- */
    root.querySelectorAll('.b5-cust__frame-card').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-frame');
        if (f === state.frame) return;
        state.frame = f;
        state.lens  = pickValidLens(state.frame, state.framecolor, state.lens);
        state.angle = pickValidAngle(state.frame, state.framecolor, state.lens, state.angle);
        render();
      });
    });

    root.querySelectorAll('.b5-cust__color-card').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var c = btn.getAttribute('data-frame-color');
        if (c === state.framecolor) return;
        state.framecolor = c;
        state.lens  = pickValidLens(state.frame, state.framecolor, state.lens);
        state.angle = pickValidAngle(state.frame, state.framecolor, state.lens, state.angle);
        render();
      });
    });

    root.querySelectorAll('.b5-cust__sig-row .b5-sig-dot').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var l = btn.getAttribute('data-lens');
        if (l === state.lens) return;
        state.lens  = l;
        state.angle = pickValidAngle(state.frame, state.framecolor, state.lens, state.angle);
        render();
      });
    });

    root.querySelectorAll('.b5-cust__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var a = btn.getAttribute('data-angle');
        if (a === state.angle) return;
        state.angle = a;
        render();
      });
    });

    /* Prev / next arrows — cycle through the 4 angles (fr → cn → sd → bk
       and wrap). Skip any angle whose photo doesn't exist for the
       current frame+color+lens so users never land on a 404 view. */
    var ANGLE_ORDER = ['fr', 'cn', 'sd', 'bk'];
    function stepAngle(direction) {
      var i = ANGLE_ORDER.indexOf(state.angle);
      for (var n = 0; n < ANGLE_ORDER.length; n++) {
        i = (i + direction + ANGLE_ORDER.length) % ANGLE_ORDER.length;
        var next = ANGLE_ORDER[i];
        if (hasPhoto(state.frame, state.framecolor, next, state.lens)) {
          state.angle = next;
          render();
          return;
        }
      }
    }
    var $navPrev = root.querySelector('.b5-cust__nav--prev');
    var $navNext = root.querySelector('.b5-cust__nav--next');
    if ($navPrev) $navPrev.addEventListener('click', function () { stepAngle(-1); });
    if ($navNext) $navNext.addEventListener('click', function () { stepAngle(1); });

    /* Touch swipe — drag the stage left/right to step through angles.
       Threshold 40px so taps and tiny jitter don't trigger. */
    var $stage = root.querySelector('.b5-cust__stage');
    if ($stage) {
      var touchStartX = 0, touchStartY = 0, touchActive = false;
      $stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchActive = true;
      }, { passive: true });
      $stage.addEventListener('touchend', function (e) {
        if (!touchActive) return;
        touchActive = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - touchStartX;
        var dy = t.clientY - touchStartY;
        // Only act on a mostly-horizontal swipe past the threshold.
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          stepAngle(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
    }

    root.querySelectorAll('[data-rx-type]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.rxType = btn.getAttribute('data-rx-type');
        render();
      });
    });

    root.querySelectorAll('[data-rx-method]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.rxMethod = btn.getAttribute('data-rx-method');
        root.querySelectorAll('[data-rx-method]').forEach(function (b) {
          var on = b.getAttribute('data-rx-method') === state.rxMethod;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        render();
      });
    });

    /* Populate the Rx selects, wire the upload dropzone, and wire the
       PD help toggles. All three use shared top-level helpers so the
       PDP flow (initRxFlow) gets identical behavior. */
    populateRxSelects(root);
    initRxDropzone(document.getElementById('cust-rx-dropzone'));
    initPdHelpToggles(root);

    var $tryonToggle = document.getElementById('cust-tryon-toggle');
    if ($tryonToggle) {
      $tryonToggle.addEventListener('click', function () {
        state.tryon = !state.tryon;
        $tryonToggle.setAttribute('aria-pressed', state.tryon ? 'true' : 'false');
      });
    }

    /* Sticky ATC visibility — appears once the main ATC scrolls off
       screen. Click proxies to the main ATC so all click-handlers
       attached there (cart logic, "added" feedback) keep working
       through a single source of truth. */
    if ($stickyBar && $mainAtc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting;
          $stickyBar.classList.toggle('visible', visible);
          $stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe($mainAtc);
    }
    if ($stickyBtn && $mainAtc) {
      $stickyBtn.addEventListener('click', function () { $mainAtc.click(); });
    }

    /* Initial paint (URL write still gated off) — then arm address-bar
       syncing so every subsequent selection updates the shareable URL. */
    render();
    addrBarSync = true;
  }


  /* ==========================================================================
     7. Product Gallery — thumbnail swap
     - Clicking a thumbnail (.b5-gallery__thumb) swaps the main image source.
     - The clicked thumb gets the "active" class; all others lose it.
     ========================================================================== */

  /* Highway 1 buy-box overlays: image counter (bottom-right) and worn-tag
     (top-right, only on video views). Used by both the gallery thumb
     handler and the signature swatch handler so the worn-tag text stays
     in sync when the user changes the lens combination while a video plays. */
  function updateGalleryOverlays() {
    var thumbs = document.querySelectorAll('.b5-gallery__thumb');
    if (!thumbs.length) return;
    var activeThumb = document.querySelector('.b5-gallery__thumb.active') || thumbs[0];
    var counter = document.getElementById('gallery-count');
    var worn = document.getElementById('gallery-worn');

    /* 01 / 06 style counter, zero-padded */
    if (counter) {
      var total = thumbs.length;
      var idx = Array.prototype.indexOf.call(thumbs, activeThumb) + 1;
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      counter.textContent = pad(idx) + ' / ' + pad(total);
    }

    /* Worn overlay only renders on the two video thumbs. The label must
       describe the variant actually in the video — which for Sam can differ
       from the currently-selected swatch (Sam falls back to a default
       variant when no exact Sam shot exists for the picked combo). Parse
       the thumb's data-video filename to recover the {frame,lens} actually
       playing, then look up that swatch's frame-label + lens-name. */
    if (worn) {
      if (activeThumb.classList.contains('b5-gallery__thumb--video')) {
        var labelSwatch = null;
        var vFrame = activeThumb.dataset.wornFrame;
        var vLens  = activeThumb.dataset.wornLens;
        if (vFrame && vLens) {
          labelSwatch = document.querySelector(
            '.b5-sig-dot[data-frame="' + vFrame + '"][data-lens="' + vLens + '"], ' +
            '.b5-sig-half[data-frame="' + vFrame + '"][data-lens="' + vLens + '"], ' +
            '.b5-sig-thumb[data-frame="' + vFrame + '"][data-lens="' + vLens + '"]'
          );
        }
        /* Fall back to the active swatch if parsing fails (legacy thumbs
           without the structured data-video filename). */
        if (!labelSwatch) {
          labelSwatch = document.querySelector('.b5-sig-dot.active, .b5-sig-half.active, .b5-sig-thumb.active');
        }
        var frameLabel = labelSwatch ? (labelSwatch.dataset.frameLabel || '') : '';
        var lensName   = labelSwatch ? (labelSwatch.dataset.name || '') : '';
        worn.innerHTML =
          (frameLabel ? '<div>' + frameLabel + '</div>' : '') +
          (lensName ? '<div>' + lensName + ' lens</div>' : '');
        worn.classList.add('visible');
      } else {
        worn.innerHTML = '';
        worn.classList.remove('visible');
      }
    }
  }

  /* Tag the main gallery image with .view-<angle> (e.g., .view-fr,
     .view-bk) so per-view CSS rules (object-position adjustments) can
     re-center off-axis source photos like the back-view shot. */
  function syncMainViewClass(angle) {
    var mainImg = document.querySelector('.b5-gallery__main img');
    if (!mainImg) return;
    mainImg.className = mainImg.className.replace(/\bview-\w+\b/g, '').trim();
    if (angle && angle !== 'video') mainImg.classList.add('view-' + angle);
  }

  function initGallery() {
    var galleryMain = document.querySelector('.b5-gallery__main');
    var mainImg = galleryMain ? galleryMain.querySelector('img') : null;
    var thumbs = document.querySelectorAll('.b5-gallery__thumb');
    if (!galleryMain || !thumbs.length) return;

    /* Set initial counter / worn-tag state + view class on page load.
       The first thumb (data-angle="fr") is .active by default. */
    updateGalleryOverlays();
    var initialActive = document.querySelector('.b5-gallery__thumb.active');
    if (initialActive) syncMainViewClass(initialActive.dataset.angle);

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var thumbType = thumb.dataset.type || 'image';
        var nextAngle = thumb.dataset.angle;

        /* Update active state */
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');

        /* Counter + worn overlay update immediately. The per-view class
           (which controls per-angle transforms) is deferred to the same
           tick as the src swap below — otherwise the current image would
           visibly slide to the new transform mid-fade before the new
           image's src takes its place. */
        updateGalleryOverlays();

        if (thumbType === 'video') {
          /* Video has no view-* class. Swap immediately — there's no
             transform to slide. */
          syncMainViewClass(nextAngle);

          /* Show video in main gallery */
          var videoSrc = thumb.dataset.video;
          if (!videoSrc) return;

          /* Remove existing video if present */
          var existingVideo = galleryMain.querySelector('video');
          if (existingVideo) existingVideo.remove();

          /* Build the video element off-DOM and start buffering. We DON'T
             hide the gallery image yet — the user keeps looking at the
             existing photo while the video buffers in the background.
             Once `canplay` fires, swap the image for the (already
             buffered) video in a single tick so it appears to play
             instantly. This matches desktop behaviour (where buffer is
             fast enough to feel instant) instead of showing the static
             poster mid-buffer on slow mobile networks. */
          var video = document.createElement('video');
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          video.preload = 'auto';
          video.style.cssText = 'width:100%;height:100%;object-fit:cover;';
          /* Propagate the talent identity so CSS can apply person-specific
             framing (Jacob was shot wider than Sam — we scale him to match). */
          if (thumb.dataset.person) video.dataset.person = thumb.dataset.person;
          /* Poster only acts as a fallback if `canplay` somehow never
             fires (e.g. broken video file). With our swap-on-canplay
             logic below, users on a healthy network never see it. */
          var posterImg = thumb.querySelector('img');
          if (posterImg && posterImg.src) video.poster = posterImg.src;
          video.src = videoSrc;

          var swapped = false;
          function swapInVideo() {
            if (swapped) return;
            swapped = true;
            /* Only swap if this is still the active thumb — user may
               have clicked away during the buffer. */
            if (!thumb.classList.contains('active')) return;
            if (mainImg) mainImg.style.display = 'none';
            galleryMain.appendChild(video);
            var p = video.play();
            if (p && typeof p.catch === 'function') {
              p.catch(function () { /* autoplay denied — no-op */ });
            }
          }
          /* Primary trigger: video has buffered enough to start playing. */
          video.addEventListener('canplay', swapInVideo, { once: true });
          /* Safety net: if buffering takes too long (very slow network or
             a stalled response), swap in anyway after 2.5s so the user
             isn't left looking at the wrong frame indefinitely. The
             video's own poster will then fill in until data arrives. */
          setTimeout(swapInVideo, 2500);

        } else {
          /* Show image — remove any video first */
          var existingVideo = galleryMain.querySelector('video');
          if (existingVideo) existingVideo.remove();

          if (mainImg) {
            mainImg.style.display = 'block';
            var newSrc = thumb.dataset.img || (thumb.querySelector('img') ? thumb.querySelector('img').src : null);
            if (!newSrc) return;

            mainImg.style.opacity = '0';
            setTimeout(function () {
              /* Swap src AND view class together while opacity is 0, so
                 the transform change is invisible. */
              mainImg.src = newSrc;
              syncMainViewClass(nextAngle);
              mainImg.style.opacity = '1';
            }, 200);
          }
        }
      });
    });

    /* ---------- Arrow nav + swipe gesture ----------
       Reuses existing thumb click handlers so all image/video swap logic
       stays in one place. Arrow buttons live inside .b5-gallery__main. */
    var prevBtn = galleryMain.querySelector('.b5-gallery__nav--prev');
    var nextBtn = galleryMain.querySelector('.b5-gallery__nav--next');

    function advance(delta) {
      var thumbsArr = Array.prototype.slice.call(thumbs);
      var activeIdx = thumbsArr.indexOf(document.querySelector('.b5-gallery__thumb.active'));
      if (activeIdx < 0) activeIdx = 0;
      var nextIdx = (activeIdx + delta + thumbsArr.length) % thumbsArr.length;
      thumbsArr[nextIdx].click();
      /* Scroll the thumb strip to keep the newly active thumb visible */
      thumbsArr[nextIdx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      advance(-1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      advance(1);
    });

    /* Keyboard arrow navigation — left/right cycles through gallery
       views. Skips when the user is typing in a form field. Guard the
       .matches() call because e.target may be the document itself when
       no element has focus (and document has no .matches method). */
    document.addEventListener('keydown', function (e) {
      var t = e.target;
      if (t && typeof t.matches === 'function' &&
          t.matches('input, textarea, select, [contenteditable]')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); advance(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); advance(1); }
    });

    /* Touch swipe on the main gallery area (mobile). Threshold: 40px. */
    var touchStartX = null;
    galleryMain.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches.length === 1) touchStartX = e.touches[0].clientX;
    }, { passive: true });
    galleryMain.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var endX = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : touchStartX;
      var dx = endX - touchStartX;
      touchStartX = null;
      if (Math.abs(dx) < 40) return;
      advance(dx < 0 ? 1 : -1);
    });
  }


  /* ==========================================================================
     8b. Signature Combination Selector (b5-sig-dot / b5-sig-half / b5-sig-thumb)
     - Handles the new signature selector on product pages.
     - Clicking a swatch updates the description panel + gallery images.
     ========================================================================== */

  function initSignatureSelector() {
    var swatches = document.querySelectorAll('.b5-sig-dot, .b5-sig-half, .b5-sig-thumb');
    if (!swatches.length) return;

    /* Gallery elements */
    var gallery = document.querySelector('.b5-gallery');
    var galleryMain = document.querySelector('.b5-gallery__main');
    var mainImg = galleryMain ? galleryMain.querySelector('img') : null;
    /* All gallery thumbs, addressed by data-angle. Image thumbs have
       fr/cn/sd/bk; video thumbs have angle="video" and are skipped here. */
    var thumbs = document.querySelectorAll('.b5-gallery__thumb');

    /* Description panel elements (all optional) */
    var descContainer = document.getElementById('sig-desc');
    var descName = document.getElementById('sig-name');
    var descCopy = document.getElementById('sig-copy');
    var descMeta = document.getElementById('sig-meta');
    var descNotes = document.getElementById('sig-notes');
    var descFrame = document.getElementById('sig-frame-color');
    var descMicro = document.getElementById('sig-micro');

    /* Detect frame model: prefer explicit data-frame-model on the gallery,
       fall back to parsing the current main image filename. */
    var frameModel = 'h1';
    if (gallery && gallery.dataset.frameModel) {
      frameModel = gallery.dataset.frameModel;
    } else if (mainImg && mainImg.src) {
      var filename = mainImg.src.split('/').pop();
      if (filename.indexOf('dav') === 0) frameModel = 'dav';
      else if (filename.indexOf('fp') === 0) frameModel = 'fp';
    }

    /* Build the src for a given angle. Side profile ignores lens color
       because there's only one side shot per frame color. */
    function srcFor(angle, frame, lens) {
      if (angle === 'sd') {
        return cdn('images/' + frameModel + '-' + frame + '-sd.jpg');
      }
      return cdn('images/' + frameModel + '-' + frame + '-' + angle + '-' + lens + '.jpg');
    }

    /* Portrait try-on videos follow `{model}-{person}-{frame}-{lens}.mp4`
       with a matching `-poster.jpg`. Jacob has full coverage so we just
       generate the path. Sam was shot in a partial roster — when the
       current variant isn't in the covered list, we fall back to that
       model's default Sam shot. */
    var SAM_FALLBACK = {
      h1:  { covered: ['brn/b15', 'brn/cr15'], _default: 'brn/cr15' },
      dav: { covered: ['brn/cr15svm'],         _default: 'brn/cr15svm' },
      fp:  { covered: ['blk/g15'],             _default: 'blk/g15' }
    };

    function resolveVideoAsset(person, frame, lens) {
      if (!person || !frame || !lens) return null;
      var useFrame, useLens;
      if (person === 'jacob') {
        useFrame = frame;
        useLens  = lens;
      } else if (person === 'sam') {
        var samCfg = SAM_FALLBACK[frameModel];
        if (!samCfg) return null;
        var key = frame + '/' + lens;
        var useKey = samCfg.covered.indexOf(key) >= 0 ? key : samCfg._default;
        var parts = useKey.split('/');
        useFrame = parts[0];
        useLens  = parts[1];
      } else {
        return null;
      }
      var slug = frameModel + '-' + person + '-' + useFrame + '-' + useLens;
      return {
        video:  cdn('videos/' + slug + '.mp4'),
        poster: cdn('images/' + slug + '-poster.jpg'), wornFrame: useFrame, wornLens: useLens
      };
    }

    /* Shared updater for the gallery + description panel. Called by the
       swatch click handler (with fade) and by the URL pre-select path
       (instant — skips the opacity dance so the page doesn't flash the
       default variant before snapping to the requested one). */
    function applySwatch(swatch, instant) {
      var frameColor = swatch.dataset.frame;
      var lensColor = swatch.dataset.lens;
      var lensName = swatch.dataset.name;
      var lensDesc = swatch.dataset.desc;
      var lensMeta = swatch.dataset.meta;
      var lensMetaStyle = swatch.dataset.metaStyle;
      var lensNotes = swatch.dataset.notes;
      var lensNotesStyle = swatch.dataset.notesStyle;
      var lensMicro = swatch.dataset.micro;
      var frameLabel = swatch.dataset.frameLabel;

      swatches.forEach(function (s) { s.classList.remove('active'); });
      swatch.classList.add('active');

      if (descName) descName.textContent = lensName || '';
      if (descCopy) descCopy.textContent = lensDesc || '';
      if (descMeta) descMeta.textContent = lensMeta || '';
      if (descContainer) {
        /* Strip any existing section-level variant modifier classes
           so the activating dot starts clean, then re-apply (if any).
           Variants cascade from #sig-desc down to its description,
           meta, and notes children. Used by the highway 1 demo to
           switch between cascade / bracketed / lowercase treatments;
           harmless on other product pages. */
        descContainer.classList.remove(
          'b5-sig-desc--cascade',
          'b5-sig-desc--bracketed',
          'b5-sig-desc--lowercase'
        );
        if (lensMetaStyle) {
          descContainer.classList.add('b5-sig-desc--' + lensMetaStyle);
        }
      }
      if (descNotes) {
        descNotes.textContent = lensNotes || '';
        /* Strip any existing variant modifier, then re-apply based on
           the swatch's data-notes-style (smaller / dash / italic).
           Used by the davenport A/B demo; harmless elsewhere. */
        descNotes.classList.remove(
          'b5-sig-desc__notes--smaller',
          'b5-sig-desc__notes--dash',
          'b5-sig-desc__notes--italic'
        );
        if (lensNotesStyle) {
          descNotes.classList.add('b5-sig-desc__notes--' + lensNotesStyle);
        }
      }
      if (descFrame) descFrame.textContent = frameLabel || '';
      if (descMicro) descMicro.textContent = lensMicro || '';

      if (galleryMain) {
        var existingVideo = galleryMain.querySelector('video');
        if (existingVideo) existingVideo.remove();
        if (mainImg) mainImg.style.display = 'block';
      }

      /* Preserve the current angle unless the user was on a video, in
         which case snap to the front thumb in the new color. */
      var activeThumb = document.querySelector('.b5-gallery__thumb.active');
      var activeAngle = activeThumb && activeThumb.dataset.angle;
      var wasOnVideo = activeAngle === 'video';
      if (!activeAngle || activeAngle === 'video') activeAngle = 'fr';

      if (wasOnVideo) {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        var frThumb = document.querySelector('.b5-gallery__thumb[data-angle="fr"]');
        if (frThumb) frThumb.classList.add('active');
        syncMainViewClass('fr');
      }

      if (mainImg && frameColor) {
        var newMainSrc = srcFor(activeAngle, frameColor, lensColor);
        if (instant) {
          /* Synchronous swap, no fade — avoids the visible flash when
             the page opens with a URL-driven variant. */
          mainImg.src = newMainSrc;
          mainImg.style.opacity = '1';
        } else {
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.src = newMainSrc;
            mainImg.style.opacity = '1';
          }, 200);
        }
      }

      thumbs.forEach(function (thumb) {
        var angle = thumb.dataset.angle;
        if (!angle) return;
        if (angle === 'video') {
          /* Repoint the video thumb at the current variant's portrait
             try-on. The existing gallery click handler reads data-video
             and the inner <img>.src, so updating those is all that's
             needed — playback wiring stays untouched. */
          var asset = resolveVideoAsset(thumb.dataset.person, frameColor, lensColor);
          if (asset) {
            var posterImg = thumb.querySelector('img');
            if (posterImg) posterImg.src = asset.poster;
            thumb.dataset.video = asset.video; thumb.dataset.wornFrame = asset.wornFrame; thumb.dataset.wornLens = asset.wornLens;
          }
          return;
        }
        var thumbImg = thumb.querySelector('img');
        var newThumbSrc = srcFor(angle, frameColor, lensColor);
        if (thumbImg) thumbImg.src = newThumbSrc;
        thumb.dataset.img = newThumbSrc;
      });

      var addBtn = document.querySelector('.b5-btn--add-cart');
      var priceEl = document.getElementById('display-price');
      if (addBtn && priceEl) {
        addBtn.textContent = 'add to cart — ' + priceEl.textContent;
      }

      /* Update every "build your own" / "customize" link with the
         current frame model + active swatch state so the customize
         page opens with the user's PDP selection pre-loaded.
         Targets both link variants used across the PDPs:
         .b5-product-sig-intro__link (Highway 1) and
         .b5-product-customize-link (Davenport / Fort Point). */
      var customizeUrl = (window.BASN5_URLS && window.BASN5_URLS.customize || '/products/basn5-customize') + '?style=' + frameModel +
                         '&color=' + frameColor +
                         '&lens=' + lensColor;
      document.querySelectorAll(
        '.b5-product-sig-intro__link, .b5-product-customize-link'
      ).forEach(function (link) {
        link.setAttribute('href', customizeUrl);
      });

      /* Reflect the chosen frame color + lens in the address bar so the page
         URL deep-links to this exact variant (shareable). replaceState keeps
         the back button clean; editing the existing URL preserves other params.
         Guarded on frameColor && lensColor: this selector ('.b5-sig-dot' ...)
         ALSO matches the customize page's lens dots, which carry data-lens but
         no data-frame — applySwatch is otherwise a harmless no-op there, but we
         must not let it write color=undefined over the customize page's own URL
         (the customize render() owns that page's address bar). */
      try {
        if (window.history && history.replaceState && frameColor && lensColor) {
          var sharedUrl = new URL(window.location.href);
          sharedUrl.searchParams.set('color', frameColor);
          sharedUrl.searchParams.set('lens', lensColor);
          sharedUrl.searchParams.delete('frame'); // normalize away the legacy param name
          history.replaceState(null, '', sharedUrl.toString());
        }
      } catch (e) { /* no-op if URL/history unavailable */ }

      updateGalleryOverlays();
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        applySwatch(swatch, false);
      });
    });

    /* If we arrived with ?color=X&lens=Y in the URL (a shared deep-link, or
       a homepage card click), find the matching swatch and apply it instantly
       so the page opens on the requested variant without the default flashing
       first. 'color' is canonical; 'frame' is the legacy param name kept so
       any older shared/card links still resolve. */
    try {
      var params = new URLSearchParams(window.location.search);
      var wantFrame = params.get('color') || params.get('frame');
      var wantLens = params.get('lens');
      if (wantFrame && wantLens) {
        var match = null;
        swatches.forEach(function (s) {
          if (!match && s.dataset.frame === wantFrame && s.dataset.lens === wantLens) {
            match = s;
          }
        });
        if (match) applySwatch(match, true);
      }
    } catch (e) { /* no-op if URL params unavailable */ }
  }


  /* ==========================================================================
     8c. Rx Flow — Full Conditional Logic
     - Handles the new multi-step prescription flow on product pages.
     ========================================================================== */

  /* Render the ATC trust copy as two segments split on the "·" so each phrase can
     sit on its own line. Also toggles .is-rx on the parent .b5-product-atc-sub so the
     CSS can choose one line (with the dot, when it fits) vs two stacked lines (mobile
     always, or desktop on the longer Rx copy). Shared by the PDP Rx flow + customize. */
  function renderTrust(el, str, isRx) {
    if (!el) return;
    var parts = String(str || '').split('·').map(function (s) { return s.trim(); }).filter(Boolean);
    if (parts.length) {
      el.innerHTML = '';
      parts.forEach(function (p) {
        var span = document.createElement('span');
        span.className = 'b5-atc-sub__seg';
        span.textContent = p;
        el.appendChild(span);
      });
    }
    var sub = el.closest ? el.closest('.b5-product-atc-sub') : null;
    if (sub) sub.classList.toggle('is-rx', !!isRx);
  }

  function initRxFlow() {
    var rxToggle = document.getElementById('rx-toggle');
    var rxSwitch = document.getElementById('rx-switch');
    if (!rxToggle) return;

    var rxStepType = document.getElementById('rx-step-type');
    var rxStepMethod = document.getElementById('rx-step-method');
    var rxUpload = document.getElementById('rx-upload');
    var rxInputs = document.getElementById('rx-inputs');
    var rxLater = document.getElementById('rx-later');
    var rxTryon = document.getElementById('rx-tryon');
    var rxTable = document.getElementById('rx-table');
    var tryonProgressive = document.getElementById('rx-tryon-progressive');
    var priceEl = document.getElementById('display-price');
    var addBtn = document.querySelector('.b5-btn--add-cart');

    var basePrice = priceEl ? parseInt(priceEl.dataset.basePrice, 10) : 365;
    var rxPrice = 0;
    var rxActive = false;

    /* Wire shared helpers: select population, dropzone, PD help toggles.
       These work the same on PDPs as on the customize page since both
       call sites point at .b5-cust__* class-named elements. */
    populateRxSelects(document);
    initRxDropzone(document.getElementById('rx-dropzone'));
    initPdHelpToggles(document);

    function updatePrice() {
      var total = basePrice + (rxActive ? rxPrice : 0);
      if (priceEl) priceEl.textContent = '$' + total;
      if (addBtn) addBtn.textContent = 'add to cart — $' + total;
    }

    /* Trust-strip text swaps between a base "ships within N business days"
       message and the Rx-orders "ships from confirmed Rx" message depending
       on whether the Rx toggle is active. Both strings live on the element
       as data-attributes so the copy can be tuned per page without touching
       JS. */
    var trustEl = document.getElementById('atc-trust-text');
    function updateTrust() {
      if (!trustEl) return;
      var next = rxActive ? trustEl.dataset.rx : trustEl.dataset.default;
      renderTrust(trustEl, next, rxActive);
    }

    function hideAllMethodPanels() {
      if (rxUpload) rxUpload.classList.remove('visible');
      if (rxInputs) rxInputs.classList.remove('visible');
      if (rxLater) rxLater.classList.remove('visible');
    }

    /* Toggle Rx on/off */
    rxToggle.addEventListener('click', function () {
      rxActive = !rxActive;
      if (rxSwitch) {
        rxSwitch.classList.toggle('active', rxActive);
        rxSwitch.setAttribute('aria-checked', rxActive ? 'true' : 'false');
      }
      if (rxStepType) rxStepType.classList.toggle('visible', rxActive);
      if (rxStepMethod) rxStepMethod.classList.toggle('visible', rxActive);
      if (rxTryon) rxTryon.classList.toggle('visible', rxActive);

      if (!rxActive) {
        rxPrice = 0;
        hideAllMethodPanels();
      } else {
        /* Default to single vision + send later */
        rxPrice = 250;
        if (rxLater) rxLater.classList.add('visible');
      }
      updatePrice();
      updateTrust();
    });

    /* Rx type buttons (single vision / progressive). On progressive the
       Rx table swaps to its 5-column variant (revealing the ADD column)
       and the seg-height note inside the home try-on box appears. */
    var typeButtons = rxStepType ? rxStepType.querySelectorAll('.b5-rx-option') : [];
    typeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        typeButtons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        rxPrice = parseInt(btn.dataset.rxPrice, 10) || 0;
        updatePrice();

        var isProgressive = btn.dataset.rxType === 'progressive';
        if (rxTable) rxTable.classList.toggle('is-progressive', isProgressive);
        if (tryonProgressive) tryonProgressive.classList.toggle('is-visible', isProgressive);
      });
    });

    /* Rx method buttons (later / type / upload) */
    var methodButtons = rxStepMethod ? rxStepMethod.querySelectorAll('.b5-rx-option') : [];
    methodButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        methodButtons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        hideAllMethodPanels();

        var method = btn.dataset.rxMethod;
        if (method === 'upload' && rxUpload) rxUpload.classList.add('visible');
        if (method === 'type' && rxInputs) rxInputs.classList.add('visible');
        if (method === 'later' && rxLater) rxLater.classList.add('visible');
      });
    });

    /* Home try on checkbox — keyboard-accessible (role=checkbox, Space/Enter,
       aria-checked kept in sync with the .checked class the cart bridge reads). */
    var tryonToggle = document.getElementById('rx-tryon-toggle');
    var tryonCheck = document.getElementById('rx-tryon-check');
    if (tryonToggle && tryonCheck) {
      tryonCheck.setAttribute('role', 'checkbox');
      tryonCheck.setAttribute('tabindex', '0');
      tryonCheck.setAttribute('aria-checked', tryonCheck.classList.contains('checked') ? 'true' : 'false');
      tryonCheck.setAttribute('aria-label', 'Home Try-On');
      function syncTryonAria() {
        tryonCheck.setAttribute('aria-checked', tryonCheck.classList.contains('checked') ? 'true' : 'false');
      }
      tryonToggle.addEventListener('click', function () {
        tryonCheck.classList.toggle('checked');
        syncTryonAria();
      });
      tryonCheck.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          tryonCheck.classList.toggle('checked');
          syncTryonAria();
        }
      });
    }

    /* Keyboard support for Rx switch */
    if (rxSwitch) {
      rxSwitch.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          rxToggle.click();
        }
      });
    }

    /* Fort Point accordion-style rx flow: clicking a step label toggles
       its expanded state. Folded in from the Fort Point inline script. */
    var rxAccordion = document.querySelector('.b5-rx-accordion');
    if (rxAccordion) {
      rxAccordion.querySelectorAll('.b5-rx-step').forEach(function (step) {
        var label = step.querySelector('.b5-rx-step__label');
        if (!label) return;
        label.addEventListener('click', function () {
          step.classList.toggle('visible');
        });
      });
    }

    /* Initial render so the trust strip shows as two segments on load (before any toggle). */
    updateTrust();
  }


  /* ==========================================================================
     10. Add to Cart Button Animation
     - On click, briefly swaps the button text to a "Added ✓" confirmation,
       then reverts after 2 seconds.
     ========================================================================== */

  /* ==========================================================================
     basn5 ⇄ Shopify cart bridge  (injected by scripts/build-basn5-js.js)
     Replaces the static-site ATC stub. Reads the live selection from the DOM
     (PDP signature selector + Customize configurator), maps it to a single
     Shopify variant via SKU (BASN5-{STYLE}-{COLOR}-{LENS}-{RXCODE} where the Rx
     option bakes the upcharge into the variant price + tax), and adds ONE cart
     line via multipart /cart/add.js carrying the BCPO Rx properties + the native
     file upload (properties[Upload Rx Here] -> /uploads CDN URL).
     Globals injected per-template: window.BASN5_CDN, BASN5_VARIANTS, BASN5_URLS
     ========================================================================== */

  // Cap JS-loaded images at 2160px via Shopify's CDN transform — also flips the
  // response to WebP/AVIF. Matches the build scripts' static &width= treatment
  // (dev/build/cdn-width.js); videos and already-transformed URLs pass through.
  function basn5CdnWidth(url) {
    if (!/\.(jpe?g|png|webp)(\?|$)/i.test(url) || /[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=2160';
  }

  // Resolve a local "images/.." or "videos/.." ref to its Shopify CDN URL.
  function cdn(p) {
    if (!p) return p;
    if (/^(https?:)?\/\//.test(p)) return basn5CdnWidth(p);   // already an absolute/CDN URL (e.g. file_url'd attrs)
    var map = window.BASN5_CDN || {};
    if (map[p]) return basn5CdnWidth(map[p]);
    if (window.console && console.warn) console.warn('[basn5] no CDN url for', p);
    return p;
  }

  var BASN5_CRLF = String.fromCharCode(13) + String.fromCharCode(10); // real \r\n for the Type-in-Rx string

  var BASN5_STYLE_NAMES = { dav: 'Davenport', fp: 'Fort Point', h1: 'Highway 1' };
  var BASN5_COLOR_NAMES = { blk: 'Black', brn: 'Brown' };
  var BASN5_METHOD_LABELS = { later: 'Send In Later', type: 'Type In Now', upload: 'Upload Now' };
  var BASN5_RX_CODE = { none: 'NONE', single: 'SV', progressive: 'PROG' };

  function basn5FindVariant(style, color, lens, rxCode) {
    if (!style || !color || !lens || !rxCode) return null;
    var sku = ('BASN5-' + style + '-' + color + '-' + lens + '-' + rxCode).toUpperCase();
    var vs = window.BASN5_VARIANTS || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i] && String(vs[i].sku || '').toUpperCase() === sku) return vs[i];
    }
    return null;
  }

  // Read frame/color/lens + Rx state from the DOM for either page type.
  function basn5ReadSelection() {
    var isCust = !!document.querySelector('.b5-cust');
    var sel = { isCust: isCust };
    if (isCust) {
      var styleEl = document.querySelector('.b5-cust__frame-card.is-active');
      var colorEl = document.querySelector('.b5-cust__color-card.is-active');
      var lensEl = document.querySelector('.b5-cust__sig-row .b5-sig-dot.active');
      sel.style = styleEl && styleEl.getAttribute('data-frame');
      sel.color = colorEl && colorEl.getAttribute('data-frame-color');
      sel.lens = lensEl && lensEl.getAttribute('data-lens');
      var typeEl = document.querySelector('[data-rx-type].is-active');
      sel.rxType = typeEl ? typeEl.getAttribute('data-rx-type') : 'none';
      var methodEl = document.querySelector('[data-rx-method].is-active');
      sel.rxMethod = methodEl ? methodEl.getAttribute('data-rx-method') : 'later';
      sel.rxRoot = document.querySelector('.b5-cust');
      sel.fileInput = document.querySelector('#cust-rx-dropzone .b5-cust__rx-dropzone-input') ||
                      document.querySelector('.b5-cust__rx-dropzone-input');
      sel.lensName = lensEl && lensEl.getAttribute('data-name');
    } else {
      var gallery = document.getElementById('gallery');
      sel.style = gallery && gallery.getAttribute('data-frame-model');
      var dot = document.querySelector('.b5-sig-dot.active, .b5-sig-half.active, .b5-sig-thumb.active');
      sel.color = dot && dot.getAttribute('data-frame');
      sel.lens = dot && dot.getAttribute('data-lens');
      sel.lensName = dot && dot.getAttribute('data-name');
      var rxSwitch = document.getElementById('rx-switch');
      var rxOn = !!(rxSwitch && rxSwitch.classList.contains('active'));
      if (rxOn) {
        var t = document.querySelector('#rx-step-type .b5-rx-option[data-rx-type].active');
        sel.rxType = t ? t.getAttribute('data-rx-type') : 'single';
        var m = document.querySelector('#rx-step-method .b5-rx-option[data-rx-method].active');
        sel.rxMethod = m ? m.getAttribute('data-rx-method') : 'later';
      } else {
        sel.rxType = 'none';
        sel.rxMethod = 'later';
      }
      sel.rxRoot = document;
      sel.fileInput = document.getElementById('rx-file');
    }
    sel.rxCode = BASN5_RX_CODE[sel.rxType] || 'NONE';   // -> SKU suffix (single variant carries the Rx)
    return sel;
  }

  // Home Try-On toggle (PDP: #rx-tryon-check.checked; Customize: #cust-tryon-toggle[aria-pressed]).
  function basn5HomeTryOnSelected() {
    var pdp = document.getElementById('rx-tryon-check');
    if (pdp && pdp.classList.contains('checked')) return true;
    var cust = document.getElementById('cust-tryon-toggle');
    if (cust && cust.getAttribute('aria-pressed') === 'true') return true;
    return false;
  }

  // --- Type-in-Rx serializer (byte-exact to BCPO; see scripts/bcpo-property-keys.json) ---
  function basn5FmtDiopter(val) {
    if (val === '' || val == null) return null;
    var n = parseFloat(val);
    if (isNaN(n)) return null;
    if (n > 0) return '+' + n.toFixed(2);
    if (n < 0) return n.toFixed(2);   // toFixed keeps the leading minus
    return '0.00';                     // plano is unsigned
  }
  function basn5FmtAxis(selectEl) {
    var v = selectEl ? selectEl.value : '';
    if (v === '' || v == null) return null;
    if (v === 'na') return 'N/A';
    var n = parseInt(v, 10);
    if (isNaN(n)) return null;
    return String(n);                  // integer, no sign, no zero-pad
  }
  function basn5RxSelect(root, field, eye) {
    return root.querySelector('[data-rx-field="' + field + '"][data-rx-eye="' + eye + '"]');
  }
  // Returns the combined Rx string. Omitted fields are allowed and render byte-exactly
  // like BCPO's blank format (e.g. "(SPH: ,  CYL: ,  AXIS: )"); filled fields use two
  // spaces after the colon ("SPH:  -3.00"). Never blocks add-to-cart.
  function basn5SerializeRx(root, isProgressive) {
    function dio(f, e) { var s = basn5RxSelect(root, f, e); return basn5FmtDiopter(s ? s.value : '') || ''; }
    function ax(e) { return basn5FmtAxis(basn5RxSelect(root, 'axis', e)) || ''; }
    function field(label, v) { return label + ': ' + (v ? ' ' + v : ''); }
    function seg(eye) {
      var parts = [field('SPH', dio('sph', eye)), field('CYL', dio('cyl', eye)), field('AXIS', ax(eye))];
      if (isProgressive) parts.push(field('ADD', dio('add', eye)));
      return '(' + parts.join(',  ') + ')';
    }
    return 'OD (Right): ' + seg('od') + ' ' + BASN5_CRLF + ' OS (Left): ' + seg('os');
  }

  function basn5Notify(msg) {
    try { window.alert(msg); } catch (e) { /* noop */ }
  }

  function basn5Esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // Update the basn5 header cart badge (#cart-icon-bubble .b5-nav__cart-badge).
  function basn5UpdateCartCount(n) {
    n = Number(n) || 0;
    var badge = document.querySelector('#cart-icon-bubble .b5-nav__cart-badge');
    var link = document.getElementById('cart-icon-bubble');
    if (badge) { badge.textContent = n > 0 ? n : ''; badge.classList.toggle('is-visible', n > 0); }
    if (link) { link.setAttribute('data-cart-count', n); link.setAttribute('aria-label', 'Cart, ' + n + ' items'); }
  }
  function basn5SyncCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { basn5UpdateCartCount(c.item_count); })
      .catch(function () {});
  }

  // basn5-styled "added to cart" confirmation — self-contained inline styles, no
  // dependency on Dawn or any app CSS (the standalone store has no BCPO app).
  // The slide-out cart drawer is wired separately; this is the immediate confirm.
  function basn5ShowAddedModal(sel) {
    var prev = document.getElementById('basn5-added-modal'); if (prev) prev.remove();
    var title = 'basn5 ' + (BASN5_STYLE_NAMES[sel.style] || sel.style || '');
    var variant = (BASN5_COLOR_NAMES[sel.color] || sel.color || '') + (sel.lensName ? ' / ' + sel.lensName : '');
    var rxLine = (sel.rxType === 'single' || sel.rxType === 'progressive')
      ? (sel.rxType === 'progressive' ? 'Progressive' : 'Single Vision') + ' prescription' : '';
    var imgEl = document.getElementById('gallery-main') || document.getElementById('cust-image') || document.querySelector('.b5-gallery__main img');
    var imgSrc = imgEl ? imgEl.src : '';
    var V = 'var(--b5-verdigris, #789F90)';

    var wrap = document.createElement('div');
    wrap.id = 'basn5-added-modal';
    wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-label', 'Added to cart');
    wrap.style.cssText = 'position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.45);font-family:Manrope,sans-serif;padding:20px;';
    wrap.innerHTML =
      '<div style="background:#fff;max-width:420px;width:100%;border-radius:6px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.25);">' +
        '<div style="padding:18px 24px;border-bottom:1px solid #eee;font-size:12px;letter-spacing:.1em;text-transform:uppercase;color:#666;">added to cart &#10003;</div>' +
        '<div style="display:flex;gap:16px;padding:24px;align-items:center;">' +
          (imgSrc ? '<img src="' + basn5Esc(imgSrc) + '" alt="" width="84" height="84" style="width:84px;height:84px;object-fit:cover;border-radius:4px;flex:none;background:#f5f5f5;">' : '') +
          '<div style="min-width:0;">' +
            '<div style="font-weight:600;font-size:16px;">' + basn5Esc(title) + '</div>' +
            '<div style="font-size:14px;color:#444;margin-top:2px;">' + basn5Esc(variant) + '</div>' +
            (rxLine ? '<div style="font-size:13px;color:' + V + ';margin-top:4px;">' + basn5Esc(rxLine) + '</div>' : '') +
          '</div>' +
        '</div>' +
        '<div style="display:flex;gap:10px;padding:0 24px 24px;">' +
          '<button type="button" id="basn5-modal-keep" style="flex:1;padding:13px;border:1px solid #ccc;background:#fff;color:#111;-webkit-appearance:none;appearance:none;border-radius:4px;font:inherit;font-size:14px;cursor:pointer;">keep shopping</button>' +
          '<a href="/cart" style="flex:1;padding:13px;background:#000;color:#fff;border-radius:4px;text-align:center;font-size:14px;text-decoration:none;display:flex;align-items:center;justify-content:center;">view cart</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);
    // Focus management: move focus into the dialog on open, return it on close.
    var prevFocus = document.activeElement;
    function close() {
      wrap.remove();
      if (!prevFocus || typeof prevFocus.focus !== 'function') return;
      try { prevFocus.focus(); } catch (e) { /* noop */ }
      // The ATC button stays disabled ~2.5s after an add (double-add guard) and a
      // disabled button can't take focus — retry once after the cooldown.
      if (document.activeElement !== prevFocus && prevFocus.isConnected) {
        setTimeout(function () { try { prevFocus.focus(); } catch (e) { /* noop */ } }, 2600);
      }
    }
    var keep = wrap.querySelector('#basn5-modal-keep');
    if (keep) { keep.addEventListener('click', close); keep.focus(); }
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
  }

  function basn5AddError(r) {
    return r.json().then(function (e) { throw e; }, function () { throw { description: 'Add to cart failed (' + r.status + ').' }; });
  }

  function basn5Submit(btn) {
    var sel = basn5ReadSelection();
    if (!sel.style || !sel.color || !sel.lens) { basn5Notify('Please choose a frame color and lens before adding to cart.'); return; }
    var variant = basn5FindVariant(sel.style, sel.color, sel.lens, sel.rxCode);
    if (!variant) { basn5Notify('Sorry — that combination is currently unavailable.'); return; }

    var rxOn = sel.rxType === 'single' || sel.rxType === 'progressive';
    var props = {}, file = null;

    if (rxOn) {
      // NB: the Rx TYPE (Single Vision / Progressive) is carried by the variant's "Prescription"
      // option, so we deliberately do NOT also set a "Prescription Type" line-item property — that
      // duplicated the variant in the cart/checkout/order. Keep only the non-redundant Rx detail.
      props['Prescription Information'] = BASN5_METHOD_LABELS[sel.rxMethod] || 'Send In Later';
      if (sel.rxMethod === 'type') {
        props['Type in Rx'] = basn5SerializeRx(sel.rxRoot, sel.rxType === 'progressive');  // blanks allowed
      } else if (sel.rxMethod === 'upload') {
        // Upload is OPTIONAL — never block the order on a missing file. "Prescription Information"
        // already records the "Upload Now" intent; we follow up for the file afterward if needed.
        file = (sel.fileInput && sel.fileInput.files && sel.fileInput.files[0]) || null;
      }
      if (sel.rxMethod === 'type' || sel.rxMethod === 'upload') {
        // Each page renders TWO .b5-cust__pd-row-input fields (one in the type-in panel,
        // one in the upload panel). Read the one in the ACTIVE method's panel, else PD is dropped.
        var pdRoot = sel.rxMethod === 'upload'
          ? (sel.rxRoot.querySelector('#rx-upload') || sel.rxRoot.querySelector('#cust-rx-upload'))
          : (sel.rxRoot.querySelector('#rx-inputs') || sel.rxRoot.querySelector('#cust-rx-inputs'));
        var pdEl = (pdRoot || sel.rxRoot).querySelector('.b5-cust__pd-row-input');
        var pd = pdEl ? pdEl.value.trim() : '';
        if (pd) props['Pupillary Distance #(s)'] = pd;
      }
    }
    // Home Try-On lives inside the Rx flow and only makes sense for a prescription
    // order. The toggle's checked state (.checked / aria-pressed) persists in the DOM
    // after switching back to non-prescription — the panel just hides — so gate on the
    // active Rx flow (rxOn) rather than the toggle alone, or the property leaks onto a
    // non-Rx line item.
    if (rxOn && basn5HomeTryOnSelected()) props['Home Try-On'] = 'Yes';

    var orig = btn.getAttribute('data-orig-label') || btn.textContent;
    btn.setAttribute('data-orig-label', orig);
    btn.disabled = true; btn.style.pointerEvents = 'none'; btn.textContent = 'adding…';

    // ONE line: the single variant (frame + lens + Rx baked into price/tax) + Rx detail properties.
    // Multipart so the native Rx file upload (properties[Upload Rx Here] -> /uploads CDN URL) works.
    var fd = new FormData();
    fd.append('id', String(variant.id));
    fd.append('quantity', '1');
    Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
    if (file) fd.append('properties[Upload Rx Here]', file, file.name);

    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : basn5AddError(r); })
      .then(function () {
        btn.textContent = 'added ✓';
        // slide-out drawer is the confirmation; the modal remains as a fallback
        // if the drawer shell isn't on the page for any reason
        if (!basn5Drawer.open()) basn5ShowAddedModal(sel);
        basn5SyncCartCount();
        setTimeout(function () { btn.disabled = false; btn.style.pointerEvents = ''; btn.textContent = orig; }, 2500);
      })
      .catch(function (err) {
        btn.disabled = false; btn.style.pointerEvents = ''; btn.textContent = orig;
        basn5Notify((err && (err.description || err.message)) || 'Sorry, something went wrong adding to cart. Please try again.');
      });
  }

  // --- Image warmer ----------------------------------------------------------
  // Swap/hover imagery used to be preloaded all at once at init (~50-150 fetches
  // before LCP) — on phones that throttled everything, and early hovers/dot
  // clicks still missed because their image sat deep in an unordered queue.
  // Now: chunked queue (4 concurrent), staged by importance, gated off on
  // data-saver / 2g, and started after the load event so the LCP wins.

  function basn5ConnectionOK() {
    var c = navigator.connection;
    if (!c) return true;
    if (c.saveData) return false;
    return !/(^|-)2g/.test(c.effectiveType || '');
  }

  function basn5PreloadQueue(urls, done) {
    var q = urls.slice(), active = 0, CONC = 4;
    function next() {
      if (!q.length) { if (!active && done) done(); return; }
      while (active < CONC && q.length) {
        active++;
        var im = new Image();
        im.onload = im.onerror = function () { active--; next(); };
        im.src = q.shift();
      }
    }
    next();
  }

  // Stage 1 — hover/swap-critical: card hover images + the PDP swatch fronts
  // (small set; fixes "hover/dot doesn't swap until it happens to be cached").
  function basn5CollectCriticalSwapImages() {
    var urls = {}, order = [];
    // NB: file_url emits protocol-relative URLs (//cdn…) — accept those too. The
    // old preloader tested ^https?: only, which silently skipped every data-hover/
    // data-img target (why card hovers and dot swaps loaded cold).
    function add(u) { if (u && /^(https?:)?\/\//.test(u) && !urls[u]) { urls[u] = 1; order.push(u); } }
    document.querySelectorAll('[data-hover]').forEach(function (el) { add(el.getAttribute('data-hover')); });
    var gal = document.getElementById('gallery');
    if (gal && gal.dataset.frameModel) {
      var fm = gal.dataset.frameModel;
      document.querySelectorAll('.b5-sig-dot[data-frame][data-lens]').forEach(function (d) {
        add(cdn('images/' + fm + '-' + d.getAttribute('data-frame') + '-fr-' + d.getAttribute('data-lens') + '.jpg'));
      });
    }
    return order;
  }

  // Stage 2 — the rest of the swap targets. NB: the homepage card DOTS carry
  // data-front/data-corner (the image pair they swap in), not data-img.
  function basn5CollectRemainingSwapImages(already) {
    var seen = {}, order = [];
    (already || []).forEach(function (u) { seen[u] = 1; });
    document.querySelectorAll('[data-img],[data-default],[data-front],[data-corner]').forEach(function (el) {
      [el.getAttribute('data-img'), el.getAttribute('data-default'), el.getAttribute('data-front'), el.getAttribute('data-corner')].forEach(function (u) {
        if (u && /^(https?:)?\/\//.test(u) && !seen[u]) { seen[u] = 1; order.push(u); }
      });
    });
    return order;
  }

  function basn5PreloadVariantImages() {
    if (!basn5ConnectionOK()) return;
    var critical = basn5CollectCriticalSwapImages();
    basn5PreloadQueue(critical, function () {
      if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
        // desktop: plenty of bandwidth — warm every remaining swap target
        basn5PreloadQueue(basn5CollectRemainingSwapImages(critical));
      } else {
        // phones: gallery angle images first (the thumbs themselves are tiny
        // 180w files now, so taps need the real 2160w warmed), then each
        // card's dot images as the card nears the viewport / on first touch
        var angles = [];
        document.querySelectorAll('.b5-gallery__thumb[data-img]').forEach(function (t) {
          var u = t.getAttribute('data-img');
          if (u && /^(https?:)?\/\//.test(u) && critical.indexOf(u) === -1 && angles.indexOf(u) === -1) angles.push(u);
        });
        if (angles.length) basn5PreloadQueue(angles, basn5WarmCardDotsAhead);
        else basn5WarmCardDotsAhead();
      }
    });
  }

  // Mobile: a card's color-dot swap images load when the card scrolls within
  // ~900px of the viewport, and immediately on first touch anywhere on the
  // card — so by the time a thumb lands on a dot, its image is cached.
  function basn5WarmCardDotsAhead() {
    if (!basn5ConnectionOK()) return;
    var warmed = [];
    function urlsFor(card) {
      var urls = [];
      function add(u) { if (u && /^(https?:)?\/\//.test(u) && warmed.indexOf(u) === -1) { warmed.push(u); urls.push(u); } }
      add(card.getAttribute('data-hover'));
      add(card.getAttribute('data-default'));
      // dots carry the swap pair as data-front/data-corner (data-img elsewhere)
      card.querySelectorAll('[data-img],[data-front],[data-corner]').forEach(function (d) {
        add(d.getAttribute('data-img')); add(d.getAttribute('data-front')); add(d.getAttribute('data-corner'));
      });
      return urls;
    }
    var dotSets = document.querySelectorAll('.b5-card-dots, .b5-fullwidth-card__dots, .b5-overlay-card__dots');
    var cards = [];
    dotSets.forEach(function (set) {
      // exact card-root classes — substring matching ([class*=card]) hits the
      // dots container / inner wrappers ("…card__dots", "…card__bottom") instead
      var card = set.closest('.b5-overlay-card, .b5-fullwidth-card, .b5-product-card, .b5-editorial-card') ||
                 (set.parentElement && set.parentElement.closest('a')) || set.parentElement;
      if (card && cards.indexOf(card) === -1) cards.push(card);
    });
    if (!cards.length) return;
    function warm(card) {
      var urls = urlsFor(card);
      if (urls.length) basn5PreloadQueue(urls);
    }
    cards.forEach(function (card) {
      card.addEventListener('touchstart', function once() {
        card.removeEventListener('touchstart', once);
        warm(card);
      }, { passive: true });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          warm(e.target);
        });
      }, { rootMargin: '900px 0px' });
      cards.forEach(function (card) { io.observe(card); });
    } else {
      cards.forEach(warm);
    }
  }

  // Warm carousel/macro-strip images well before they scroll into view (their
  // native lazy-loading fires too late on fast mobile scrolls → visible pop-in).
  function basn5WarmStripsAhead() {
    if (!('IntersectionObserver' in window) || !basn5ConnectionOK()) return;
    var strips = document.querySelectorAll('.b5-macro-strip, .b5-carousel, .b5-triad-carousel');
    if (!strips.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var urls = [];
        e.target.querySelectorAll('img[loading="lazy"]').forEach(function (im) {
          im.loading = 'eager';
          if (im.getAttribute('src')) urls.push(im.currentSrc || im.src);
        });
        basn5PreloadQueue(urls);
      });
    }, { rootMargin: '1500px 0px' });
    strips.forEach(function (s) { io.observe(s); });
  }

  // #11 — the lifestyle/triad carousels lazy-load large photos, so they appear slowly as the
  // (auto-advancing) carousel reaches each slide. Warm them into cache AFTER first paint so the
  // initial render isn't blocked but the images are ready by the time a slide shows.
  function basn5PreloadCarousels() {
    var urls = {};
    document.querySelectorAll('.b5-carousel img, .b5-triad-carousel img, .b5-hero-slider img').forEach(function (im) {
      var u = im.getAttribute('src'); if (u && /^https?:/.test(u)) urls[u] = 1;
    });
    Object.keys(urls).forEach(function (u) { var i = new Image(); i.src = u; });
  }

  // Desktop homepage hero: it's 100vh, but Tajima's header sits above it so the bottom
  // falls below the fold. Shrink the hero container to (viewport - chrome above it) and set
  // object-position so the crop favors the top of the photo (photo stays full-size, not scaled).
  // Also caps the headline lift so it can't collide with the wordmark on short screens.
  // Mobile uses the natural-aspect hero (b5-hero-slider--mobile-natural), so leave it untouched.
  function basn5FitHero() {
    var hero = document.querySelector('.basn5-port .b5-hero-slider, .basn5-port .b5-hero');
    if (!hero) return;
    // The slider AND its inner track/slides are each 100vh, so sizing only the container
    // leaves the image overflowing. Size every nested layer; imgs are height:100% so they follow.
    var layers = [hero].concat([].slice.call(hero.querySelectorAll('.b5-hero-slider__track, .b5-hero-slider__slide, .b5-hero')));
    // Only the background photo(s) — NOT the injected basn5 wordmark logo, which has its own fixed size.
    var imgs = [].slice.call(hero.querySelectorAll('img')).filter(function (im) {
      return !(im.closest && im.closest('.basn5-hero-logo'));
    });
    var content = hero.querySelector('.b5-hero__content');
    var all = layers.concat(imgs);
    // reset height AND min-height (slides use min-height:100vh, which a plain height won't beat)
    all.forEach(function (el) { el.style.height = ''; el.style.minHeight = ''; });
    if (window.innerWidth < 768) {                              // mobile uses natural-aspect hero
      imgs.forEach(function (im) { im.style.objectPosition = ''; });
      if (content) content.style.transform = '';               // drop any desktop clamp so the mobile CSS layout wins
      return;
    }
    var docTop = hero.getBoundingClientRect().top + window.scrollY;  // chrome height above hero (scroll-independent)
    var avail = window.innerHeight - docTop;
    if (avail > 320) {
      all.forEach(function (el) { el.style.height = avail + 'px'; el.style.minHeight = avail + 'px'; });
      // --- Crop distribution -----------------------------------------------------------------------
      // DEFAULT (standard laptop height and taller): crop 70% off the top / 30% off the bottom — the
      // tuned framing where the horizon lands just under the headline and the head + sunglasses sit
      // high. This is what a standard Mac shows. As the window gets SHORTER than REF_AVAIL, only the
      // EXTRA overflow is taken 30% off the top / 70% off the bottom, so the head + sunglasses stay put
      // instead of being eaten from the top. (object-position-Y is the fraction removed off the TOP.)
      // Heights >= REF_AVAIL render IDENTICALLY to a fixed 70%, so a standard-size screen is untouched.
      var REF_AVAIL = 680;          // px of hero height at/above which the pure 70/30 default holds
      imgs.forEach(function (im) {
        if (!im.naturalWidth) { im.style.objectPosition = '50% 70%'; return; }   // pre-load: use the default split
        var scaledH = im.naturalHeight * ((im.clientWidth || window.innerWidth) / im.naturalWidth);
        var overflow = scaledH - avail;
        if (overflow <= 0) { im.style.objectPosition = '50% 50%'; return; }       // image fills height: no vertical crop
        var refOverflow = Math.max(0, scaledH - REF_AVAIL);
        var cropTop = overflow <= refOverflow
          ? 0.70 * overflow                                                       // default 70/30 split
          : 0.70 * refOverflow + 0.30 * (overflow - refOverflow);                 // 30/70 on the extra below REF_AVAIL
        var posY = Math.max(0, Math.min(1, cropTop / overflow));
        im.style.objectPosition = '50% ' + (posY * 100).toFixed(2) + '%';
      });
      // Keep the headline clear of the fixed wordmark on short viewports. The headline is vertically
      // centered then lifted by CSS translateY(-6vh); on a short hero that lift rides it up into the logo.
      // Cap the lift so the headline's top never rises above the wordmark's bottom + a 20px gap (and on a
      // very short hero, nudge it down to clear). On tall heroes the cap is slack, so -6vh applies as before.
      if (content) {
        var headline = hero.querySelector('.b5-hero__headline') || content;
        var logoEl = hero.querySelector('.basn5-hero-logo');
        var desiredUp = 0.06 * window.innerHeight;             // mirrors the CSS translateY(-6vh)
        content.style.transform = 'none';                      // measure at the natural (centered) position
        var floor = logoEl ? logoEl.getBoundingClientRect().bottom + 20 : 0;
        var up = Math.min(desiredUp, headline.getBoundingClientRect().top - floor);
        content.style.transform = 'translateY(' + (-up) + 'px)';
      }
    }
  }

  // Warm the visible model's portrait video into cache shortly after first paint so the first tap
  // plays quickly. Best-effort and CONSERVATIVE: only the single active/first video thumb, and we
  // skip entirely when the browser reports a metered ("save data") or slow (2g) connection — those
  // are the users a proactive download would hurt most. Videos otherwise load only on thumb tap.
  function basn5WarmActiveVideo() {
    // desktop-only: buffering the try-on video costs ~3MB — on phones the
    // gallery already lazy-buffers it when the video thumb is tapped
    if (window.matchMedia && !window.matchMedia('(min-width: 768px)').matches) return;
    var conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
    if (conn && (conn.saveData || /(^|\b)(slow-2g|2g)$/.test(conn.effectiveType || ''))) return;
    var thumb = document.querySelector('.b5-gallery__thumb.active[data-video], [data-video]');
    var src = thumb && thumb.getAttribute('data-video');
    if (!src || !/^https?:/.test(src)) return;
    var v = document.createElement('video');
    v.muted = true; v.preload = 'auto'; v.src = src;   // detached element — buffers into cache, never shown
  }

  // ATC trust strip (2-segment "free shipping … · ships within …"): rendered by the GOLD source's own
  // renderTrust() now — it fires on load AND on change for both the PDP (initRxFlow → updateTrust) and
  // the customize page (render()). It was duplicated here (basn5RenderTrust + basn5InitTrust) from before
  // the gold had it; removed after the §11 gold back-port so the gold is the single source of truth.

  // Carousel nav — mouse click-drag + momentum + hover arrows (desktop-mouse
  // affordance). The studio/lifestyle macro-strips and the lifestyle carousel
  // are native scroll-snap strips with the scrollbar hidden and no arrows/dots,
  // so a desktop mouse user (esp. Windows, no trackpad) has no way to advance
  // them. For fine pointers only (native touch swipe untouched): click-and-drag
  // with inertia that settles flush on a photo + minimalist chevron arrows that
  // fade in on hover (styled in basn5-overrides.css; snap is disabled there for
  // fine pointers so this owns the snapping).
  function basn5InitCarouselNav() {
    var ICON_PREV = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><polyline points="15,5 8,12 15,19"></polyline></svg>';
    var ICON_NEXT = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><polyline points="9,5 16,12 9,19"></polyline></svg>';
    var SLIDE_SEL = '.b5-macro-strip__item, .b5-carousel__slide';

    // Each target = the element that actually scrolls + the element to host arrows.
    var targets = [];
    document.querySelectorAll('.b5-macro-strip--loop').forEach(function (strip) {
      targets.push({ scroller: strip, host: strip.closest('.b5-macro-strip-wrap') || strip.parentElement });
    });
    document.querySelectorAll('.b5-carousel--loop').forEach(function (car) {
      var track = car.querySelector('.b5-carousel__track');
      if (track) targets.push({ scroller: track, host: car });
    });

    targets.forEach(function (t) {
      if (!t.scroller || !t.host || t.scroller.getAttribute('data-cnav') === '1') return;
      t.scroller.setAttribute('data-cnav', '1');
      setupCarousel(t.scroller, t.host);
    });

    function setupCarousel(scroller, host) {
      var raf = null;
      function cancelRaf() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
      function slides() { return Array.prototype.slice.call(scroller.querySelectorAll(SLIDE_SEL)); }
      function maxScroll() { return Math.max(0, scroller.scrollWidth - scroller.clientWidth); }
      // Align to the scroller's own left edge — NOT the padded edge. The lifestyle
      // carousel track has left padding, but its photos are meant to sit full-bleed
      // (flush to the edge, like the original snap did by scrolling past the
      // padding). Macro-strips have no padding, so this is a no-op there.
      function refLeft() { return scroller.getBoundingClientRect().left; }

      // Index of the slide whose left edge sits closest to the left edge.
      function nearestIndex() {
        var sl = slides(), rl = refLeft(), best = 0, bestD = Infinity;
        for (var i = 0; i < sl.length; i++) {
          var d = Math.abs(sl[i].getBoundingClientRect().left - rl);
          if (d < bestD) { bestD = d; best = i; }
        }
        return best;
      }
      // scrollLeft that lands slide i flush at the left edge.
      function targetFor(i) {
        var sl = slides();
        if (!sl.length) return scroller.scrollLeft;
        i = Math.max(0, Math.min(sl.length - 1, i));
        var delta = sl[i].getBoundingClientRect().left - refLeft();
        return Math.max(0, Math.min(scroller.scrollLeft + delta, maxScroll()));
      }
      // Whole slides visible at once — the step for arrow paging.
      function perPage() {
        var sl = slides();
        if (sl.length < 2) return 1;
        var stepW = sl[1].getBoundingClientRect().left - sl[0].getBoundingClientRect().left;
        if (stepW <= 0) return 1;
        return Math.max(1, Math.round(scroller.clientWidth / stepW));
      }

      // Smooth eased glide to an absolute scrollLeft (easeOutCubic).
      function settle(target, dur) {
        cancelRaf();
        var start = scroller.scrollLeft, dist = target - start;
        if (Math.abs(dist) < 1) { scroller.scrollLeft = target; return; }
        dur = dur || Math.min(560, Math.max(220, Math.abs(dist) * 0.5));
        var t0 = null;
        function step(ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          scroller.scrollLeft = start + dist * e;
          if (p < 1) raf = requestAnimationFrame(step); else raf = null;
        }
        raf = requestAnimationFrame(step);
      }
      function settleNearest(dur) { settle(targetFor(nearestIndex()), dur); }

      // Inertia: keep gliding at the release velocity, decay, then settle flush.
      function fling(v) { // v = content velocity in px/ms (positive => scrollLeft increasing)
        cancelRaf();
        var last = null;
        function step(ts) {
          if (last === null) last = ts;
          var dt = ts - last; last = ts;
          if (dt > 0) {
            scroller.scrollLeft = Math.max(0, Math.min(scroller.scrollLeft + v * dt, maxScroll()));
            v *= Math.pow(0.94, dt / 16);
          }
          var atEdge = scroller.scrollLeft <= 0 || scroller.scrollLeft >= maxScroll();
          if (Math.abs(v) > 0.04 && !atEdge) raf = requestAnimationFrame(step);
          else { raf = null; settleNearest(300); }
        }
        raf = requestAnimationFrame(step);
      }

      // ---- Pointer drag (mouse/pen only; native touch swipe untouched) ----
      var down = false, startX = 0, startLeft = 0, moved = false, pid = null;
      var lastX = 0, lastT = 0, vel = 0; // vel = pointer velocity px/ms
      scroller.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        if (e.button !== 0) return;
        cancelRaf();
        down = true; moved = false;
        startX = e.clientX; startLeft = scroller.scrollLeft; pid = e.pointerId;
        lastX = e.clientX; lastT = e.timeStamp; vel = 0;
        scroller.classList.add('b5-dragging');
        try { scroller.setPointerCapture(pid); } catch (err) { /* best-effort */ }
      });
      scroller.addEventListener('pointermove', function (e) {
        if (!down || e.pointerId !== pid) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        scroller.scrollLeft = startLeft - dx;
        var dt = e.timeStamp - lastT;
        if (dt > 0) { vel = (e.clientX - lastX) / dt; lastX = e.clientX; lastT = e.timeStamp; }
      });
      function end() {
        if (!down) return;
        down = false;
        scroller.classList.remove('b5-dragging');
        try { scroller.releasePointerCapture(pid); } catch (err) { /* noop */ }
        if (!moved) return;
        // Content moves opposite the pointer; fling if there's real velocity, else just settle flush.
        var cv = -vel;
        if (Math.abs(cv) > 0.05) fling(cv); else settleNearest(300);
      }
      scroller.addEventListener('pointerup', end);
      scroller.addEventListener('pointercancel', end);
      // Swallow the click after a real drag so card links/toggles don't fire.
      scroller.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      // Block the native image drag-ghost while dragging the strip.
      scroller.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // ---- Minimalist hover arrows (page by a screenful, landing flush) ----
      var prev = document.createElement('button');
      prev.type = 'button'; prev.className = 'b5-cnav b5-cnav--prev';
      prev.setAttribute('aria-label', 'Previous'); prev.innerHTML = ICON_PREV;
      var next = document.createElement('button');
      next.type = 'button'; next.className = 'b5-cnav b5-cnav--next';
      next.setAttribute('aria-label', 'Next'); next.innerHTML = ICON_NEXT;
      host.appendChild(prev); host.appendChild(next);
      prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); settle(targetFor(nearestIndex() - perPage())); });
      next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); settle(targetFor(nearestIndex() + perPage())); });

      // ---- Initial flush: the infinite-loop JS sets the start position on a
      // deferred frame; once it has, align to the nearest slide so the first
      // photo sits flush-left (no thin sliver of the previous photo). ----
      setTimeout(function () { scroller.scrollLeft = targetFor(nearestIndex()); }, 200);
    }
  }

  // Replaces the static stub. Binds the PDP ATC (.b5-btn--add-cart) and the
  // Customize ATC (#cust-atc); the sticky bars already proxy clicks here.
  function initAddToCart() {
    var seen = [];
    [document.querySelector('.b5-btn--add-cart'), document.getElementById('cust-atc')].forEach(function (btn) {
      if (!btn || seen.indexOf(btn) !== -1) return;
      seen.push(btn);
      btn.addEventListener('click', function (e) {
        if (e && e.preventDefault) e.preventDefault();
        basn5Submit(btn);
      });
    });
    try {
      basn5FitHero();
      window.addEventListener('load', basn5FitHero);
      window.addEventListener('resize', basn5FitHero);
      // warmers run AFTER load so the LCP and above-the-fold images win the network
      window.addEventListener('load', function () { setTimeout(basn5PreloadVariantImages, 250); });
      window.addEventListener('load', function () { setTimeout(basn5WarmStripsAhead, 300); });
      window.addEventListener('load', function () { setTimeout(basn5PreloadCarousels, 400); });
      window.addEventListener('load', function () { setTimeout(basn5WarmActiveVideo, 600); });
    } catch (e) { /* hero fit / preload are best-effort */ }
  }


  /* ==========================================================================
     11b. Sticky Mobile ATC Bar
     Appears below 768px when the main ATC button has scrolled out of view.
     Mirrors the active swatch's lens name and the current price, and
     proxies clicks to the main ATC so all existing logic (Rx upcharge,
     "Added \u2713" animation) runs unchanged.
     ========================================================================== */

  function initStickyAtc() {
    var sticky = document.getElementById('sticky-atc');
    var mainAtc = document.querySelector('.b5-btn--add-cart');
    var stickyFrame = document.getElementById('sticky-atc-frame');
    var stickyName = document.getElementById('sticky-atc-name');
    var stickyBtn = document.getElementById('sticky-atc-btn');
    if (!sticky || !mainAtc) return;

    /* Show sticky when main ATC is OUT of view. IntersectionObserver
       handles the visibility flip with zero scroll work. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting;
          sticky.classList.toggle('visible', visible);
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(mainAtc);
    }

    /* Update the sticky from the currently active swatch + main ATC.
       Top: "<product name> · <color> Frame" — product name first, then
       frame color, separated by a middle dot. CSS uppercases the lot.
       Bottom: "[rx ]<lens name> lens" — same noun-phrase pattern.
       "rx " prefix appears whenever the page's Rx toggle is active;
       price already differentiates single vs progressive so we don't
       spell that out. Called on init, on swatch changes, and on
       Rx/price changes (via the main ATC's mutated label). */
    function syncFromState() {
      var activeSwatch = document.querySelector('.b5-sig-dot.active');
      if (activeSwatch) {
        if (stickyFrame) {
          var productNameEl = document.querySelector('.b5-product-info__name');
          var productName = productNameEl ? productNameEl.textContent : '';
          var frameLabel = activeSwatch.dataset.frameLabel || '';
          /* frameLabel is already "Black Frame" / "Brown Frame" — use as-is. */
          stickyFrame.textContent = productName && frameLabel
            ? (productName + ' · ' + frameLabel)
            : (productName || frameLabel);
        }
        if (stickyName) {
          var lensNm = activeSwatch.dataset.name || '';
          var rxSwitchEl = document.getElementById('rx-switch');
          var rxOn = !!(rxSwitchEl && rxSwitchEl.classList.contains('active'));
          var rxPrefix = rxOn ? 'rx ' : '';
          stickyName.textContent = lensNm ? (rxPrefix + lensNm + ' lens') : '';
        }
      }
      /* Mirror the main ATC's full label (which includes price + Rx
         upcharge if active). Just clone its textContent. */
      if (stickyBtn && mainAtc) stickyBtn.textContent = mainAtc.textContent;
    }
    syncFromState();

    /* Re-sync when the main ATC label changes (the Rx flow rewrites
       its textContent whenever a prescription is selected). */
    new MutationObserver(syncFromState).observe(mainAtc, {
      childList: true, characterData: true, subtree: true,
    });

    /* Re-sync on every swatch click. We delegate at the document level
       so we pick up any future swatches too. */
    document.addEventListener('click', function (e) {
      if (e.target && typeof e.target.closest === 'function' &&
          e.target.closest('.b5-sig-dot')) {
        /* Run on the next tick so the active class has already swapped. */
        setTimeout(syncFromState, 0);
      }
    });

    /* Click proxy \u2192 trigger the real ATC click so "Added \u2713" runs. */
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        mainAtc.click();
      });
    }
  }


  /* ==========================================================================
     12. Card Hover — Image Swap
     Product cards with data-hover swap front image to corner angle on hover.
     Works on all homepages for collection, customize, and final CTA cards.
     ========================================================================== */

  function initCardHover() {
    /* Match both product cards (collection/find your frame) and
       build-teaser frames (customize section) */
    var cards = document.querySelectorAll('[data-hover]');
    cards.forEach(function (card) {
      /* Find the first <img> inside — works for product cards
         and build-teaser frames alike */
      var img = card.querySelector('img');
      if (!img) return;

      /* Phase 5 round 2: store the current "resting" image on a data
         attribute so the dot-click handler can update it after the user
         picks a new color. Without this, mouseleave always reverts to
         the closure-captured original (Gray 15) even after the user
         clicked a different color dot. */
      card.setAttribute('data-default', img.getAttribute('src'));

      card.addEventListener('mouseenter', function () {
        var hoverSrc = card.getAttribute('data-hover');
        if (hoverSrc) img.src = hoverSrc;
      });

      card.addEventListener('mouseleave', function () {
        var defaultSrc = card.getAttribute('data-default');
        if (defaultSrc) img.src = defaultSrc;
      });
    });
  }


  /* ==========================================================================
     13. Card Dots — Color Selector on Product Cards
     Small color dots beneath product cards that swap the preview image
     to a different lens color. Used on Homepage C.
     ========================================================================== */

  function initCardDots() {
    /* Support four card variants: .b5-product-card (original),
       .b5-editorial-card (Homepage D shop), .b5-fullwidth-card
       (Homepage E shop), and .b5-overlay-card (overlay-on-image
       cards used in find-your-frame). Each variant has a different
       inner image container class — find the closest matching one. */
    var dotSets = document.querySelectorAll('.b5-card-dots, .b5-fullwidth-card__dots, .b5-overlay-card__dots');
    dotSets.forEach(function (dotSet) {
      var card = dotSet.closest('.b5-product-card, .b5-editorial-card, .b5-fullwidth-card, .b5-overlay-card');
      if (!card) return;

      var img = card.querySelector('.b5-product-card__img img, .b5-editorial-card__media img, .b5-fullwidth-card__media img, .b5-overlay-card__media img');
      if (!img) return;

      var dots = dotSet.querySelectorAll('.b5-card-dot');
      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          /* Update active state */
          dots.forEach(function (d) { d.classList.remove('active'); });
          dot.classList.add('active');

          /* Swap images */
          var front = dot.getAttribute('data-front');
          var corner = dot.getAttribute('data-corner');
          if (front) {
            img.src = front;
            /* Phase 5 round 2: store the new front as the card's
               resting image so the hover handler doesn't revert it
               on mouseleave. Also update the hover target. */
            card.setAttribute('data-default', front);
            if (corner) card.setAttribute('data-hover', corner);
          }

          /* Encode the selected variant onto the parent card's href
             so the product page can pre-select it on arrival. Derive
             frame + lens codes from the data-front filename, which
             follows {model}-{frame}-{angle}-{lensTokens...}-[v2|crop].jpg.
             If parsing fails, the original href is left untouched. */
          var cardLink = card.tagName === 'A' ? card : card.closest('a');
          if (cardLink && front) {
            var fname = front.split('/').pop().split('?')[0].replace(/\.(jpe?g|png|webp)$/i, '');
            var parts = fname.split('-').filter(function (p) {
              return p !== 'v2' && p !== 'crop';
            });
            var frIdx = parts.indexOf('fr');
            if (frIdx > 0 && frIdx < parts.length - 1) {
              var frameCode = parts[frIdx - 1];
              var lensCode = parts.slice(frIdx + 1).join('');
              var baseHref = cardLink.getAttribute('href').split('?')[0];
              cardLink.setAttribute(
                'href',
                baseHref + '?color=' + encodeURIComponent(frameCode) +
                           '&lens=' + encodeURIComponent(lensCode)
              );
            }
          }
        });
      });
    });
  }


  /* ==========================================================================
     13b. Card Dot Tooltip Auto-Dismiss (TOUCH ONLY)
     Desktop relies on :hover (cursor leave dismisses naturally). On touch
     devices iOS triggers a "phantom hover" that pins the tooltip until the
     user taps somewhere else. We intercept tap → toggle .is-tooltip-visible
     for ~1.5s, then clear it. Paired with the @media (hover: none) CSS
     block that suppresses the :hover rule on touch.
     ========================================================================== */
  function initCardDotTooltipDismiss() {
    // Run only on small viewports — matches the @media (max-width: 767px)
    // breakpoint used elsewhere on the site. Desktop hover dismisses
    // naturally when the cursor moves away.
    if (window.innerWidth >= 768) return;

    var TIMEOUT_MS = 1500;
    var dots = document.querySelectorAll('.b5-card-dot');
    var dismissTimer = null;

    function clearAll() {
      dots.forEach(function (d) { d.classList.remove('is-tooltip-visible'); });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        clearAll();
        dot.classList.add('is-tooltip-visible');
        if (dismissTimer) clearTimeout(dismissTimer);
        dismissTimer = setTimeout(function () {
          dot.classList.remove('is-tooltip-visible');
          // Removing focus also clears iOS phantom-hover state on the dot
          if (dot.blur) dot.blur();
        }, TIMEOUT_MS);
      });
    });

    // Tapping anywhere outside a dot clears any visible tooltip immediately
    document.addEventListener('touchstart', function (e) {
      if (!e.target.closest || !e.target.closest('.b5-card-dot')) {
        clearAll();
        if (dismissTimer) { clearTimeout(dismissTimer); dismissTimer = null; }
      }
    }, { passive: true });
  }


  /* ==========================================================================
     13e. Overlay Card — Mobile Arrows Variant (Homepage A)
     Injects two hairline chevron buttons (left/right) into each card's
     media area, matching the PDP gallery arrow style. Tap either arrow
     or swipe horizontally to toggle between the front and corner-angle
     photo. Color-dot updates are mirrored so the arrows keep working
     after the shopper picks a new lens color. Mobile only.
     ========================================================================== */
  function initOverlayCardMobileArrows() {
    if (window.innerWidth >= 768) return;

    /* Hairline polyline chevrons — same SVG markup as the PDP gallery so
       the visual register matches exactly. */
    var ICON_PREV = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><polyline points="14,5 7,12 14,19"></polyline></svg>';
    var ICON_NEXT = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><polyline points="10,5 17,12 10,19"></polyline></svg>';

    var SWIPE_THRESHOLD = 30;

    var grids = document.querySelectorAll('.b5-overlay-grid--mobile-arrows');
    grids.forEach(function (grid) {
      var cards = grid.querySelectorAll('.b5-overlay-card');
      cards.forEach(function (card) {
        var media = card.querySelector('.b5-overlay-card__media');
        var img = media && media.querySelector('img');
        if (!media || !img) return;

        var prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'b5-overlay-card__arrow b5-overlay-card__arrow--prev';
        prev.setAttribute('aria-label', 'Previous angle');
        prev.innerHTML = ICON_PREV;

        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'b5-overlay-card__arrow b5-overlay-card__arrow--next';
        next.setAttribute('aria-label', 'Next angle');
        next.innerHTML = ICON_NEXT;

        media.appendChild(prev);
        media.appendChild(next);

        /* flipped=false → showing data-default (front)
           flipped=true  → showing data-hover (corner) */
        var flipped = false;
        function apply() {
          var src = flipped ? card.getAttribute('data-hover')
                            : card.getAttribute('data-default');
          if (src) img.src = src;
        }
        function toggle() {
          flipped = !flipped;
          apply();
        }

        function blockNavThen(e, fn) {
          e.preventDefault();
          e.stopPropagation();
          fn();
        }
        prev.addEventListener('click', function (e) { blockNavThen(e, toggle); });
        next.addEventListener('click', function (e) { blockNavThen(e, toggle); });

        /* Swipe support — also detect drag-vs-tap so a horizontal swipe
           doesn't accidentally trigger the card link's navigation. */
        var startX = 0, startY = 0, dragged = false;
        media.addEventListener('touchstart', function (e) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          dragged = false;
        }, { passive: true });
        media.addEventListener('touchmove', function (e) {
          var dx = Math.abs(e.touches[0].clientX - startX);
          var dy = Math.abs(e.touches[0].clientY - startY);
          if (dx > 10 && dx > dy) dragged = true;
        }, { passive: true });
        media.addEventListener('touchend', function (e) {
          if (!dragged) return;
          var endX = e.changedTouches[0].clientX;
          var dx = endX - startX;
          if (Math.abs(dx) >= SWIPE_THRESHOLD) toggle();
        }, { passive: true });
        /* Capture-phase click on the card so we can stop the link
           navigation BEFORE the anchor's default action runs. */
        card.addEventListener('click', function (e) {
          if (dragged) {
            e.preventDefault();
            e.stopPropagation();
            dragged = false;
          }
        }, true);

        /* Mirror color-dot swaps. initCardDots updates data-default and
           data-hover on the card; we just re-apply based on current
           flipped state so the visible image stays consistent. */
        var colorDots = card.querySelectorAll('.b5-card-dot');
        colorDots.forEach(function (cdot) {
          cdot.addEventListener('click', function () {
            /* initCardDots runs first and sets img.src to the new front.
               If we're currently showing the corner, swap to the new
               corner instead. */
            setTimeout(apply, 0);
          });
        });
      });
    });
  }


  /* ==========================================================================
     16. Hero Slider (Homepage E — Phase 5 round 4)
     Two-slide hero on Homepage E. Click navigation dots at the bottom to
     switch which slide is shown. No auto-rotate. The active slide gets the
     `is-active` class on both the slide element and its matching dot;
     CSS handles the cross-fade and z-stacking.
     ========================================================================== */

  function initHeroSlider() {
    var sliders = document.querySelectorAll('.b5-hero-slider');
    sliders.forEach(function (slider) {
      var slides = slider.querySelectorAll('.b5-hero-slider__slide');
      var dots = slider.querySelectorAll('.b5-hero-slider__dot');
      if (!slides.length || !dots.length) return;

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var target = dot.getAttribute('data-slide-target');

          slides.forEach(function (slide) {
            if (slide.getAttribute('data-slide') === target) {
              slide.classList.add('is-active');
            } else {
              slide.classList.remove('is-active');
            }
          });

          dots.forEach(function (d) {
            if (d === dot) {
              d.classList.add('is-active');
              d.setAttribute('aria-selected', 'true');
            } else {
              d.classList.remove('is-active');
              d.setAttribute('aria-selected', 'false');
            }
          });
        });
      });
    });
  }


  /* ==========================================================================
     Triad Carousel — Fade carousel for frame/hinge/lens triad sections (D + E).
     Each [data-triad-carousel] shows one slide at a time. Users advance with
     the prev/next arrows, indicator dots, or a touch swipe.
     ========================================================================== */
  function initTriadCarousels() {
    var carousels = document.querySelectorAll('[data-triad-carousel]');
    carousels.forEach(function (carousel) {
      var slides = carousel.querySelectorAll('.b5-triad-carousel__slide');
      var dots = carousel.querySelectorAll('.b5-triad-carousel__dot');
      var prev = carousel.querySelector('.b5-triad-carousel__btn--prev');
      var next = carousel.querySelector('.b5-triad-carousel__btn--next');
      if (!slides.length) return;

      var idx = 0;
      function goTo(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }

      if (prev) prev.addEventListener('click', function () { goTo(idx - 1); });
      if (next) next.addEventListener('click', function () { goTo(idx + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

      // Touch swipe — left swipe = next, right swipe = prev (vertical swipes
      // are ignored so the page can still scroll naturally).
      var startX = 0, startY = 0, swiping = false;
      carousel.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        swiping = true;
      }, { passive: true });
      carousel.addEventListener('touchend', function (e) {
        if (!swiping) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          goTo(dx < 0 ? idx + 1 : idx - 1);
        }
        swiping = false;
      });
    });
  }


  /* ==========================================================================
     Triad Mobile Swipe — Updates dot indicators as the user horizontally
     scrolls through the [data-mobile-swipe] track on mobile (≤767px). Also
     wires dot clicks to scroll to the matching card. Desktop scroll/dots
     are not used (CSS hides the dots and reverts to a 3-up grid).
     ========================================================================== */
  function initTriadMobileSwipe() {
    var tracks = document.querySelectorAll('[data-mobile-swipe]');
    if (!tracks.length) return;

    /* Two known component families use this swipe pattern; map each
       parent class to its dot + card selectors so the same handler
       can wire both. Tech-editorial = three-pillar story section.
       Fieldnotes = three editorial cards on homepage A. */
    var FAMILIES = [
      { parent: '.b5-tech-editorial', dot: '.b5-tech-editorial__dot', card: '.b5-tech-editorial__card' },
      { parent: '.b5-fieldnotes',     dot: '.b5-fieldnotes__dot',     card: '.b5-fieldnotes__card'     }
    ];

    tracks.forEach(function (track) {
      // Dots live in the same parent section, not inside the track itself
      var family = null;
      var section = null;
      for (var i = 0; i < FAMILIES.length; i++) {
        section = track.closest(FAMILIES[i].parent);
        if (section) { family = FAMILIES[i]; break; }
      }
      if (!section || !family) return;
      var dots = section.querySelectorAll(family.dot);
      var cards = track.querySelectorAll(family.card);
      if (!dots.length || !cards.length) return;

      // Pick the card whose center is closest to the track's viewport center.
      // Uses getBoundingClientRect because offsetLeft is relative to the
      // nearest positioned ancestor, which isn't necessarily the track.
      function activeIndex() {
        var trackRect = track.getBoundingClientRect();
        var trackCenter = trackRect.left + trackRect.width / 2;
        var best = 0;
        var bestDist = Infinity;
        cards.forEach(function (card, i) {
          var r = card.getBoundingClientRect();
          var cardCenter = r.left + r.width / 2;
          var d = Math.abs(cardCenter - trackCenter);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }

      function setActive(i) {
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }

      // rAF-throttled scroll listener so we don't thrash on every scroll event
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          setActive(activeIndex());
          ticking = false;
        });
      }, { passive: true });

      // Dot click → smooth-scroll the matching card into view (centered).
      // Uses getBoundingClientRect deltas so we don't rely on offsetParent.
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var card = cards[i];
          if (!card) return;
          var trackRect = track.getBoundingClientRect();
          var cardRect = card.getBoundingClientRect();
          var delta = (cardRect.left + cardRect.width / 2) - (trackRect.left + trackRect.width / 2);
          track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
        });
      });
    });
  }


  /* ==========================================================================
     Infinite-loop Macro Strip
     - Targets any .b5-macro-strip element marked with the "--loop" modifier.
     - Clones the original items twice (3 total copies in the DOM) and
       starts the user in the middle copy. When their scroll passes the
       end of the middle copy we silently jump them back by one section
       width; same in reverse near the start. This creates a seamless
       infinite scroll feel without auto-playing.
     - The strip has scroll-snap, so jumps land cleanly on item boundaries.
     - Original images are reused, so the browser only downloads each
       image once even though the DOM has 3 sets.
     ========================================================================== */

  function initInfiniteMacroStrip() {
    var strips = document.querySelectorAll('.b5-macro-strip--loop');
    if (!strips.length) return;

    strips.forEach(function (strip) {
      var originals = Array.from(strip.children);
      if (originals.length === 0) return;

      /* Append two more copies of every original child (total = 3 sets) */
      for (var pass = 0; pass < 2; pass++) {
        originals.forEach(function (item) {
          strip.appendChild(item.cloneNode(true));
        });
      }

      /* Click-to-cycle slides for review cards. Use event delegation on
         the strip so it works on every cloned copy. Each click advances
         the cycle by one (A → B → C → A …) based on how many slides the
         card actually contains. All sibling copies in the same toggle-
         group cycle in sync, so the user never sees a flicker after the
         silent infinite-scroll rewind. */
      var slideClasses = ['', 'show-b', 'show-c', 'show-d', 'show-e'];
      strip.addEventListener('click', function (e) {
        var item = e.target.closest('.b5-macro-strip__item--toggle');
        if (!item || !strip.contains(item)) return;
        var groupId = item.getAttribute('data-toggle-group');
        if (!groupId) return;

        /* How many slides does this card hold? Determines cycle length. */
        var slideCount = item.querySelectorAll('.b5-macro-strip__slide').length;
        if (slideCount < 2) return;

        /* Read current index from the existing class, then advance. */
        var currentIndex = 0;
        if (item.classList.contains('show-e')) currentIndex = 4;
        else if (item.classList.contains('show-d')) currentIndex = 3;
        else if (item.classList.contains('show-c')) currentIndex = 2;
        else if (item.classList.contains('show-b')) currentIndex = 1;
        var nextIndex = (currentIndex + 1) % slideCount;
        var nextClass = slideClasses[nextIndex];

        var allInGroup = strip.querySelectorAll(
          '.b5-macro-strip__item--toggle[data-toggle-group="' + groupId + '"]'
        );
        allInGroup.forEach(function (el) {
          el.classList.remove('show-b');
          el.classList.remove('show-c');
          el.classList.remove('show-d');
          el.classList.remove('show-e');
          if (nextClass) el.classList.add(nextClass);
        });
      });

      /* Wait until the cloned images have laid out so scrollWidth is final */
      var setUp = function () {
        var sectionWidth = strip.scrollWidth / 3;
        if (sectionWidth <= 0) {
          /* Layout not ready yet — try again next frame */
          requestAnimationFrame(setUp);
          return;
        }

        /* Start in the middle copy so the user can scroll either way */
        strip.scrollLeft = sectionWidth;

        var jumping = false;
        strip.addEventListener('scroll', function () {
          if (jumping) return;
          /* If the user has scrolled past the end of the middle copy,
             silently rewind by one section so they're now in the
             middle of the (visually identical) earlier copy. */
          if (strip.scrollLeft >= sectionWidth * 2) {
            jumping = true;
            strip.scrollLeft -= sectionWidth;
            requestAnimationFrame(function () { jumping = false; });
          } else if (strip.scrollLeft <= 0) {
            jumping = true;
            strip.scrollLeft += sectionWidth;
            requestAnimationFrame(function () { jumping = false; });
          }
        }, { passive: true });

        /* Also recompute section width on resize, in case items reflow */
        window.addEventListener('resize', function () {
          var newSectionWidth = strip.scrollWidth / 3;
          if (newSectionWidth > 0) sectionWidth = newSectionWidth;
        });
      };

      /* Defer to the next frame so cloned images have a chance to size */
      requestAnimationFrame(setUp);
    });
  }


  /* ==========================================================================
     Lifestyle carousel — seamless infinite loop
     For each .b5-carousel--loop, clone the first 3 and last 3 slides so the
     user can scroll past the edges; on scrollend (or debounced scroll for
     older browsers), if the scroll position has crossed into a clone region,
     instant-jump scrollLeft to the equivalent position in the real region.
     The jump is invisible because there's no animation and the clone content
     is identical to the real content the user is jumping to.
     ========================================================================== */
  function initInfiniteLoop() {
    document.querySelectorAll('.b5-carousel--loop').forEach(function (carousel, carouselIdx) {
      var track = carousel.querySelector('.b5-carousel__track');
      if (!track) return;
      var realSlides = Array.prototype.slice.call(track.querySelectorAll('.b5-carousel__slide'));
      var n = realSlides.length;
      if (n < 2) return;
      var cloneCount = Math.min(3, n);

      // 1. Tag real variant-toggles with unique IDs (pre-clone) so clones inherit
      realSlides.forEach(function (slide, slideIdx) {
        var toggle = slide.querySelector('.b5-carousel__variant-toggle');
        if (toggle && !toggle.getAttribute('data-card-id')) {
          toggle.setAttribute('data-card-id', 'loop-' + carouselIdx + '-' + slideIdx);
        }
      });

      // 2. Clone tail → prepend (so user can scroll left from start).
      // .reverse() before forEach so that the iteration order combined with
      // insertBefore(firstChild) leaves the prepended clones in the SAME
      // left-to-right order as the slides they mirror — i.e. the clone
      // immediately to the left of slide 1 is a clone of the LAST real
      // slide. Without this reverse, the order is flipped and the
      // scrollend reset jumps to a different image than what was visible
      // (a visible swap, the original "third-to-last vs last" flicker).
      realSlides.slice(-cloneCount).reverse().forEach(function (s) {
        var clone = s.cloneNode(true);
        clone.classList.add('b5-carousel__slide--clone');
        clone.setAttribute('aria-hidden', 'true');
        track.insertBefore(clone, track.firstChild);
      });
      // Clone head → append (so user can scroll right past end)
      realSlides.slice(0, cloneCount).forEach(function (s) {
        var clone = s.cloneNode(true);
        clone.classList.add('b5-carousel__slide--clone');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      // 3. Helpers (recomputed on demand to handle resize gracefully)
      function gapPx() {
        var g = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
        return isNaN(g) ? 0 : g;
      }
      function unit() {
        return realSlides[0].getBoundingClientRect().width + gapPx();
      }
      function realStart() { return cloneCount * unit(); }
      function realEnd()   { return realStart() + n * unit(); }

      // 4. Land on first real slide on init (after layout settles)
      requestAnimationFrame(function () { track.scrollLeft = realStart(); });

      // 5. On scroll-end, jump back into the real region if we've drifted into clones
      var resetting = false;
      function maybeReset() {
        if (resetting) return;
        var x = track.scrollLeft;
        var u = unit();
        if (x < realStart() - 1) {
          resetting = true;
          track.scrollLeft = x + n * u;
          requestAnimationFrame(function () { resetting = false; });
        } else if (x >= realEnd() - 1) {
          resetting = true;
          track.scrollLeft = x - n * u;
          requestAnimationFrame(function () { resetting = false; });
        }
      }

      if ('onscrollend' in track) {
        track.addEventListener('scrollend', maybeReset);
      } else {
        var debounceTimer;
        track.addEventListener('scroll', function () {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(maybeReset, 120);
        });
      }

      // 6. On window resize, snap back to first real slide so layout math stays valid
      window.addEventListener('resize', function () {
        requestAnimationFrame(function () { track.scrollLeft = realStart(); });
      });
    });
  }


  /* ==========================================================================
     Initialize Everything on DOM Ready
     Each init function checks for its own elements and gracefully skips
     if they aren't present on the current page.
     ========================================================================== */

  /* ==========================================================================
     basn5 slide-out cart drawer
     Markup shell: snippets/basn5-cart-drawer.liquid (rendered in theme.liquid).
     Renders /cart.js client-side: variant image, title, the 5 visible Rx
     properties (Type in Rx keeps its CRLF via pre-line), qty stepper, remove,
     order-notes (cart.note -> order.note), subtotal, checkout. Opens after
     add-to-cart and from the header cart icon; ESC / overlay / × close it.
     READ-ONLY toward the order-data contract: it never touches line properties.
     ========================================================================== */

  var basn5Drawer = (function () {
    var root, panel, itemsEl, emptyEl, footEl, countEl, subtotalEl, noteEl;
    var openerEl = null, noteTimer = null, notePending = false, busy = false;

    function $(id) { return document.getElementById(id); }

    function money(cents) {
      var n = (cents / 100).toFixed(2);
      return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function thumb(url) {
      if (!url) return '';
      if (!/[?&]width=/.test(url)) url += (url.indexOf('?') >= 0 ? '&' : '?') + 'width=240';
      return url;
    }

    function lineHTML(item) {
      var props = '';
      Object.keys(item.properties || {}).forEach(function (k) {
        var v = item.properties[k];
        if (v == null || v === '') return;
        var shown = /^https?:/.test(String(v))
          ? '<a href="' + basn5Esc(v) + '" target="_blank" rel="noopener">view file</a>'
          : basn5Esc(v);
        props += '<div class="b5-drawer__prop"><span class="b5-drawer__prop-key">' + basn5Esc(k) + ':</span> <span class="b5-drawer__prop-val">' + shown + '</span></div>';
      });
      return (
        '<div class="b5-drawer__line" data-key="' + basn5Esc(item.key) + '">' +
          '<div class="b5-drawer__line-media">' +
            (item.image ? '<img src="' + basn5Esc(thumb(item.image)) + '" alt="" width="72" height="72" loading="lazy">' : '<span class="b5-drawer__line-noimg"></span>') +
          '</div>' +
          '<div class="b5-drawer__line-info">' +
            '<div class="b5-drawer__line-top">' +
              '<span class="b5-drawer__line-title">' + basn5Esc(item.product_title) + '</span>' +
              '<span class="b5-drawer__line-price">' + money(item.final_line_price) + '</span>' +
            '</div>' +
            (item.variant_title ? '<div class="b5-drawer__line-variant">' + basn5Esc(item.variant_title) + '</div>' : '') +
            props +
            '<div class="b5-drawer__line-actions">' +
              '<span class="b5-drawer__qty">' +
                '<button type="button" data-action="dec" aria-label="Decrease quantity">&minus;</button>' +
                '<span class="b5-drawer__qty-num" aria-label="Quantity">' + item.quantity + '</span>' +
                '<button type="button" data-action="inc" aria-label="Increase quantity">+</button>' +
              '</span>' +
              '<button type="button" class="b5-drawer__remove" data-action="remove">remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }

    function render(cart) {
      if (!root) return;
      var n = cart.item_count;
      countEl.textContent = n > 0 ? ' (' + n + ')' : '';
      itemsEl.innerHTML = cart.items.map(lineHTML).join('');
      emptyEl.hidden = n > 0;
      footEl.hidden = n === 0;
      subtotalEl.textContent = money(cart.items_subtotal_price);
      if (document.activeElement !== noteEl) noteEl.value = cart.note || '';
      basn5UpdateCartCount(n);
    }

    function refresh() {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c); return c; });
    }

    function changeLine(key, quantity) {
      if (busy) return;
      busy = true;
      var line = itemsEl.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      if (line) line.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () { refresh(); })
        .then(function () { busy = false; });
    }

    function saveNote() {
      notePending = false;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ note: noteEl.value }),
      }).catch(function () { /* note is best-effort; checkout still proceeds */ });
    }

    function trapTab(e) {
      if (e.key !== 'Tab') return;
      var focusables = panel.querySelectorAll('button, a[href], textarea, input, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close();
      else trapTab(e);
    }

    function open() {
      if (!root) return false;
      openerEl = document.activeElement;
      refresh();
      root.hidden = false;
      // double rAF: let the hidden->visible frame paint before adding the
      // transition class, so the slide-in actually animates
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
      $('b5-drawer-close').focus();
      return true;
    }

    function close() {
      if (!root || root.hidden) return;
      root.classList.remove('is-open');
      document.removeEventListener('keydown', onKeydown);
      document.body.style.overflow = '';
      setTimeout(function () { root.hidden = true; }, 380);
      if (openerEl && typeof openerEl.focus === 'function') { try { openerEl.focus(); } catch (e) { /* noop */ } }
    }

    function init() {
      root = $('b5-drawer-root');
      if (!root) return;
      panel = $('b5-drawer');
      itemsEl = $('b5-drawer-items');
      emptyEl = $('b5-drawer-empty');
      footEl = $('b5-drawer-foot');
      countEl = $('b5-drawer-count');
      subtotalEl = $('b5-drawer-subtotal');
      noteEl = $('b5-drawer-note');

      $('b5-drawer-close').addEventListener('click', close);
      $('b5-drawer-overlay').addEventListener('click', close);

      itemsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-action]');
        if (!btn) return;
        var line = btn.closest('.b5-drawer__line');
        var key = line.getAttribute('data-key');
        var qty = parseInt(line.querySelector('.b5-drawer__qty-num').textContent, 10) || 1;
        if (btn.dataset.action === 'inc') changeLine(key, qty + 1);
        else if (btn.dataset.action === 'dec') changeLine(key, qty - 1);   // 0 removes
        else if (btn.dataset.action === 'remove') changeLine(key, 0);
      });

      noteEl.addEventListener('input', function () {
        notePending = true;
        clearTimeout(noteTimer);
        noteTimer = setTimeout(saveNote, 700);
      });
      noteEl.addEventListener('blur', function () { if (notePending) { clearTimeout(noteTimer); saveNote(); } });

      $('b5-drawer-checkout').addEventListener('click', function () {
        clearTimeout(noteTimer);
        var go = function () { window.location.href = '/checkout'; };
        if (notePending || noteEl.value !== '') saveNote().then(go, go);
        else go();
      });

      // header cart icon opens the drawer (plain left-clicks only; the /cart page
      // stays reachable via modified clicks and the drawer's "view full cart")
      var cartLink = document.getElementById('cart-icon-bubble') || document.querySelector('.b5-nav__cart');
      if (cartLink) {
        cartLink.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
          e.preventDefault();
          open();
        });
      }
    }

    return { init: init, open: open, close: close, refresh: refresh };
  })();

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initMobileMenu();
    initSmoothScroll();
    initFadeIn();
    initCarousels();
    // Lifestyle loop: clone slides first
    initInfiniteLoop();
    initInfiniteMacroStrip();
    initAccordions();
    initDetailsAccordion();
    initCustomize();
    initGallery();
    initSignatureSelector();
    initRxFlow();
    initAddToCart();
    initStickyAtc();
    initCardHover();
    initCardDots();
    initCardDotTooltipDismiss();
    initOverlayCardMobileArrows();
    initTriadCarousels();
    initTriadMobileSwipe();
    initHeroSlider();
    basn5InitCarouselNav();
    basn5Drawer.init();
  });

})();
